
// (function() {
//   giftBoxBuilder = {
//       selector: {
//           firstStepBoxButton: '.js-your-box-button',
//           toolbarElement: '.js-toolbar',
//           stepOne: '.js-stage-1',
//           stepTwo: '.js-stage-2',
//           stepThree: '.js-stage-3',
//           stepFour: '.js-stage-4',
//           scondStepProducts: '.js-second-step-product',
//           nextButton: '.js-next-button',
//           completeButton: '.js-complete-button',
//           editButton: '.js-edit-button',
//           editModel: '.js-edit-model',
//           thirdStepProducts: '.js-third-product-button',
//           closeModel: '.js-close-model',
//           totalPrice: '.js-total-price',
//           giftMessage: '.js-gift-message',
//           deliveryOption: '[name=delivery-option]',
//           addToGiftButton: '.js-add-to-gift-button',
//           changeBox: '.js-change-box',
//           chnageBoxButton: '.js-change-your-box-button',
//           productInfo: '.js-product-info',
//           productThirdInfo: '.js-product-third-info'
//       },
//       init: function() {

//           this.firstStepButtons = document.querySelectorAll(this.selector.firstStepBoxButton);
//           this.giftBoxToolBar = document.querySelector(this.selector.toolbarElement);
//           this.stepOneElement = document.querySelector(this.selector.stepOne);
//           this.stepTwoElement = document.querySelector(this.selector.stepTwo);
//           this.stepThreeElement = document.querySelector(this.selector.stepThree);
//           this.stepFourElement = document.querySelector(this.selector.stepFour);
//           this.secondStepProductButtons = document.querySelectorAll(this.selector.scondStepProducts);
//           this.thirdStepProductButtons = document.querySelectorAll(this.selector.thirdStepProducts);
//         //   this.nextButtonElement = document.querySelector(this.selector.nextButton);
//           this.completeButtonElement = document.querySelector(this.selector.completeButton);
//           this.editButtonElement = document.querySelector(this.selector.editButton);
//           this.editModelElement = document.querySelector(this.selector.editModel);
//           this.closeModelElement = document.querySelector(this.selector.closeModel);
//           this.totalPriceElement = document.querySelector(this.selector.totalPrice);
//           this.giftMessageElement = document.querySelector(this.selector.giftMessage);
//           this.deliveryOptionElements = document.querySelectorAll(this.selector.deliveryOption);
//           this.addToGiftButtonElement = document.querySelector(this.selector.addToGiftButton);
//           this.changeBoxElement = document.querySelector(this.selector.changeBox);
//           this.changeBoxButtonElement = document.querySelectorAll(this.selector.chnageBoxButton);
//           this.productInfoElement = document.querySelectorAll(this.selector.productInfo);
//           this.productThirdInfoElement = document.querySelectorAll(this.selector.productThirdInfo);
//           this.boxProductArr = JSON.parse(localStorage.getItem("second-step-product")) || [];
//           this.extProductArr = JSON.parse(localStorage.getItem("third-step-product")) || [];
//           this.stepTwoProducts = [];
//           this.stepThreeProducts = [];
//           this.stepCount = 1;
//           this.allProductPrice = [];

//           // ── Image cache: build handle→src map from DOM immediately (no fetch needed for toolbar) ──
//           this._imageCache = {};
//           document.querySelectorAll(".box-item").forEach((boxItem) => {
//               const btn = boxItem.querySelector(".js-second-step-product");
//               if (!btn) return;
//               const handle = btn.getAttribute("data-second-step-product-handle");
//               if (!handle) return;
//               // grab the first visible img in the card (already rendered by Liquid)
//               const img = boxItem.querySelector("img");
//               // grab price text already rendered by Liquid
//               const priceEl = boxItem.querySelector(".box-item__price");
//               const priceText = priceEl ? priceEl.textContent.trim() : "";
//               const title = btn.getAttribute("data-product-title") || img?.alt || handle;
//               if (img && img.src) {
//                   this._imageCache[handle] = { src: img.src, alt: title, title: title, price: priceText };
//               }
//           });

//           this.bindEvent();

//       },
//       bindEvent: function() {
//           const _this = this
//           // console.log(this.firstStepButtons)
//           localStorage.removeItem("first-step-product");
//           localStorage.removeItem("second-step-product");
//           localStorage.removeItem("third-step-product");
//           localStorage.removeItem("boxProduct");
//           localStorage.removeItem("extraProduct");
//           localStorage.removeItem("first-product-count");
//           localStorage.removeItem("box-total-price");
//           localStorage.removeItem("extra-total-price");
        
//           this.stepFirstButton = this.firstStepButtons.forEach((firstStepButton) => firstStepButton.addEventListener("click", _this.toolBarEvent.bind(this), true));
//           this.stepFirstButton = this.firstStepButtons.forEach((firstStepButton) => firstStepButton.addEventListener("click", _this.selectFirstStep.bind(this), true));
//           this.stepSecondButtons = this.secondStepProductButtons.forEach((secondStepProductButton) => secondStepProductButton.addEventListener("click", _this.selectSecondStep.bind(this), true));
//           this.stepThirdButtons = this.thirdStepProductButtons.forEach((thirdStepProductButton) => thirdStepProductButton.addEventListener("click", _this.selectThirdStep.bind(this), true));
//         //   this.nextButtonElement.addEventListener("click", _this.nextStep.bind(this), true);
//           this.completeButtonElement.addEventListener("click", _this.completeBox.bind(this), true);
//           this.editButtonElement.addEventListener("click", _this.editBox.bind(this), true);
//           this.closeModelElement.addEventListener("click", _this.closeModel.bind(this), true);
//           this.addToGiftButtonElement.addEventListener("click", _this.addToGiftBox.bind(this), true);
//           document.querySelectorAll(".js-change-your-box-button").forEach((changeStepButton) => changeStepButton.addEventListener("click", _this.selectFirstStep.bind(this), true));
//           document.querySelectorAll(".js-change-your-box-button").forEach((changeStepButton) => changeStepButton.addEventListener("click", _this.toolBarEvent.bind(this), true));
//           this.productInfoElement.forEach((item) => item.addEventListener("click", _this.openProductInfo.bind(this), true));
//           this.productThirdInfoElement.forEach((item) => item.addEventListener("click", _this.openProductThirdInfo.bind(this), true))
//           document.querySelectorAll(".js-close-button").forEach((close)=> close.addEventListener("click", _this.closeProductInfo.bind(this), true));
//           document.querySelectorAll(".js-close-third-button").forEach((close)=> close.addEventListener("click", _this.closeProductThirdInfo.bind(this), true));

//           // ── Quantity minus buttons ──────────────────────────────────────────
//           document.querySelectorAll(".js-qty-minus").forEach((minusBtn) => {
//               minusBtn.addEventListener("click", function(event) {
//                   event.stopPropagation();

//                   const boxItem = minusBtn.closest(".box-item");
//                   const handle = boxItem
//                       .querySelector(".js-second-step-product")
//                       .getAttribute("data-second-step-product-handle");

//                   // Find the last added product entry with this handle
//                   const lastIndex = _this.stepTwoProducts
//                       .map((p, i) => p.handle === handle ? i : -1)
//                       .filter(i => i !== -1)
//                       .pop();

//                   if (lastIndex === undefined) return;

//                   const uid = _this.stepTwoProducts[lastIndex].id;

//                   // Remove from array
//                   _this.stepTwoProducts.splice(lastIndex, 1);

//                   // Update localStorage
//                   localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

//                   // ── Redraw toolbar instantly from cache ──
//                   _this._redrawToolbar();

//                   // Disable complete/next since box is now underfilled
//                   document.querySelector(".js-complete-button").setAttribute("disabled", "");
//                   document.querySelectorAll(".js-step-3-button").forEach(b => b.setAttribute("disabled", ""));

//                   // Update qty display counter
//                   _this._updateQtyDisplay(handle);

//                   // Sync + button state (re-enable if inventory allows)
//                   _this._syncAllButtonsForHandle(handle);

//                   // Remove corresponding entry from the sidebar items list
//                   const editBoxItem = document.querySelector(".js-box-item");
//                   if (editBoxItem) {
//                       editBoxItem.querySelectorAll(".items-list").forEach(el => {
//                           if (el.querySelector(`[data-remove-item="${uid}"]`)) el.remove();
//                       });
//                   }
//               });
//           });
//           // ───────────────────────────────────────────────────────────────────
        
//           document.querySelectorAll(".js-step-2-button").forEach((secondStepButton) => {
//               secondStepButton.addEventListener("click", function(event) {

//                   if (secondStepButton.hasAttribute("disabled") === false) {
//                       // Hide all steps first
//                       _this.stepOneElement.classList.add("hidden");
//                       _this.stepTwoElement.classList.add("hidden");
//                       _this.stepThreeElement.classList.add("hidden");
                      
//                       // Show step 2
//                       _this.stepTwoElement.classList.remove("hidden");
//                       _this.stepCount = 2;
                      
//                     //   document.querySelector(".js-complete-button").classList.add("hidden");
//                       document.querySelector(".js-toolbar").classList.remove("hidden");
//                   }
//               });
//           });
          
//           document.querySelectorAll(".js-step-1-button").forEach((firstStepButton) => {
//               firstStepButton.addEventListener("click", function(event) {
//                   // Hide all steps first
//                   _this.stepOneElement.classList.add("hidden");
//                   _this.stepTwoElement.classList.add("hidden");
//                   _this.stepThreeElement.classList.add("hidden");
                  
//                   // Show step 1
//                   _this.stepOneElement.classList.remove("hidden");
//                   _this.stepCount = 1;
                  
//                 //   document.querySelector(".js-complete-button").classList.add("hidden");
//                   document.querySelector(".js-toolbar").classList.add("hidden");
//               });
//           });


//          document.querySelectorAll(".js-step-3-button").forEach((ThirdStepButton) => {
//             ThirdStepButton.addEventListener("click", function(event) {
//                 if (!this.hasAttribute("disabled")) {
//                     _this.completeBox.call(_this, event);
//                 }
//             });
//          });
//                 //   document.querySelectorAll(".js-step-4-button").forEach((fourStepButton) => {
//         //       fourStepButton.addEventListener("click", _this.completeBox.bind(this))
//         //   });
//           this.changeBoxElement.addEventListener("click", function(event) {
//               document.querySelector(".js-change-box-popup").classList.remove("hidden");
//                document.querySelector("body").classList.add("popup-open");
//           })
//           document.querySelector(".js-change-popup-close").addEventListener("click", function() {
//               document.querySelector(".js-change-box-popup").classList.add("hidden");
//               document.querySelector("body").classList.remove("popup-open");
           
//           });
//         if( document.querySelector(".js-prev") ||  document.querySelector(".js-next")){

//           document.querySelector(".js-prev").addEventListener("click", function(){
//             document.querySelector(".gift-box-box-selector__box-list").classList.add("auto-scrolling");
//             setTimeout(()=>{
//               document.querySelector(".gift-box-box-selector__box-list").classList.remove("auto-scrolling");
//             },100)
//           })
//            document.querySelector(".js-next").addEventListener("click", function(){
//             document.querySelector(".gift-box-box-selector__box-list").classList.add("auto-scrolling");
//             setTimeout(()=>{
//               document.querySelector(".gift-box-box-selector__box-list").classList.remove("auto-scrolling");
//             },100)
//           })
//         }

//       },
   
//       toolBarEvent: function(event) {
//           this.giftBoxToolBar.classList.remove("hidden");
//           const productCount = event.target.closest(".js-box-product").getAttribute("data-product");
//           this.giftBoxToolBar.querySelector(".js-current-selection").innerHTML = `Box Items: ${productCount}`;
//           this.giftBoxToolBar.querySelector(".js-current-selection").setAttribute("data-product-count", productCount);
//           const toolBarItems = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
//         // console.log(productCount)
//           toolBarItems.forEach((item, index) => {
//               if (index >= parseInt(productCount)) {

//                   item.classList.add("hidden");
//               } else {

//                   item.classList.remove("hidden");
//               }
//           });
//           document.querySelector(".js-change-box-popup").classList.add("hidden");
//       },
//       openProductInfo: function(event){
//         event.target.closest(".box-item").querySelector(".js-product-modal").classList.remove("hidden");
//          document.querySelector("body").classList.add("popup-open");
//       },
//       closeProductInfo: function(event){
//         event.target.closest(".js-product-modal").classList.add("hidden");
//          document.querySelector("body").classList.remove("popup-open");
//       },
//       openProductThirdInfo: function(event){
//         // console.log(event.target)
//         event.target.closest(".box-item").querySelector(".js-product-third-modal").classList.remove("hidden");
//          document.querySelector("body").classList.add("popup-open");
//       },
//       closeProductThirdInfo: function(event){
//         event.target.closest(".js-product-third-modal").classList.add("hidden");
//          document.querySelector("body").classList.remove("popup-open");
//       },
//       refreshStepTwoInventoryState: function() {

//             const _this = this;

//             // Collect unique handles from all second-step product buttons
//             const handles = new Set();
//             document.querySelectorAll(".js-second-step-product[data-second-step-product-handle]").forEach((btn) => {
//                 const handle = btn.getAttribute("data-second-step-product-handle");
//                 if (handle) handles.add(handle);
//             });

//             // Use unified helper to sync both qty+ and add-to-box buttons per handle
//             handles.forEach((handle) => {
//                 _this._syncAllButtonsForHandle(handle, false);
//             });

//         },

//       selectFirstStep: function(event) {
//           // console.log(event)
//           const _this = this;
//           const firstStepProductHandle = event.target.getAttribute("data-product-handle");
//           const productCountForStepOne = event.target.getAttribute("data-product-count");
//           const toolBarItems = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
//           const extraBoxItem = document.querySelector(".js-extra-item");
//           localStorage.setItem("first-step-product", firstStepProductHandle);
//           localStorage.setItem("first-product-count", productCountForStepOne);
//            document.querySelector("body").classList.remove("popup-open");
//           this.stepOneElement.classList.add("hidden");
//           this.stepTwoElement.classList.remove("hidden");
//           _this.refreshStepTwoInventoryState();
//           this.stepThreeElement.classList.add("hidden");
//           this.stepCount = this.stepCount + 1;
//           let fetchPromises = [];
//           const editBoxItem = document.querySelector(".js-box-item");
//           document.querySelectorAll(".js-step-2-button").forEach((secondStepButton) => {
//               secondStepButton.removeAttribute("disabled");
//           });
//         //   document.querySelector(".js-next-button").classList.remove("hidden");
//         //   document.querySelector(".js-complete-button").classList.add("hidden");
//           const productCount = parseInt(localStorage.getItem("first-product-count"));
//           if (_this.stepTwoProducts.length > productCount) {
//               toolBarItems.forEach((li, index) => {
//                   if (li.querySelector("img") && index === _this.stepTwoProducts.length - 1) {

//                       li.querySelector("img").remove();
//                   }
//               });
//              if(productCount == parseInt(productCountForStepOne)){
//                   if(_this.stepTwoProducts.length > productCount){
//                       let deleteItem = _this.stepTwoProducts.length - productCount
//                       _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);        
//                   }else{
//                       let deleteItem = _this.stepTwoProducts.length - productCount
//                       _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);        
//                   }
//                 }
//                 if(productCount == parseInt(productCountForStepOne)){
//                   let deleteItem = _this.stepTwoProducts.length - productCount
//                     _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);
  
//                 }
//                 if(productCount == parseInt(productCountForStepOne)){
//                   let deleteItem = _this.stepTwoProducts.length - productCount
//                     _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);
//                 }
//           }
//           console.log(productCount,_this.stepTwoProducts.length)
//           localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

//           // ── Redraw toolbar instantly from cache ──
//           _this._redrawToolbar();
          
//           // 👉 UPDATE ALL QUANTITY DISPLAYS after products are removed
//           _this._updateQtyDisplay();

//           if (_this.stepTwoProducts.length === productCount) {
//             //   document.querySelector(".js-next-button").removeAttribute("disabled");
//             document.querySelector(".js-complete-button").removeAttribute("disabled");
//               document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
//                   thirdStepButton.removeAttribute("disabled");
//               });
//             //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
//             //       forthStepButton.removeAttribute("disabled");
//             //   });
//           } else {
//             //   document.querySelector(".js-next-button").setAttribute("disabled", "");
//              document.querySelector(".js-complete-button").setAttribute("disabled", "");
//               document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
//                   thirdStepButton.setAttribute("disabled", "");
//               });
//             //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
//             //       forthStepButton.setAttribute("disabled", "");
//             //   });
//           }
//           for (let  product of _this.stepTwoProducts) {
//               fetchPromises.push(
//                   fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
//                   .then(res => {
//                       if (!res.ok) {
//                           throw new Error(`HTTP error! Status: ${res.status}`);
//                       }
//                       return res.json();
//                   })
//                   .then(request => {
//                       if (!request || Object.keys(request).length === 0) {
//                           throw new Error('Empty response or invalid JSON');
//                       }
//                       return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };
//                   })
//                   .catch(error => {
//                       console.error(`Error fetching or processing product ${product}:`, error);
//                       return { id: null, html: '' }; // Return placeholder data to maintain sequence
//                   })
//               );

//           }
//           Promise.all(fetchPromises)
//               .then(results => {
//                  const productMiniItems = [];
//                   const imageItem = [];
//                   results = results.filter(result => result.id !== null);
                  
//                   for (let [i,productData] of results.entries()) {
//                     const { uid, id, title, image, price } = productData;
//                       let currentProductHtml = `<div class="items-list" data-id="${id}">
//                           <div class="items-list__item">
//                             <div class="item-image">
//                               <img src="${image}" alt="${title}">
//                             </div>
//                             <div class="item-title-remove">
//                               <h4>${title}</h4>
//                               <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
//                               <button class="delete-btn js-remove-item" data-remove-item="${uid}">Remove</button>
//                             </div>
//                           </div>
//                         </div>`
//                       productMiniItems.push(currentProductHtml);
//                       // toolbar already redrawn instantly above — no insertAdjacentHTML here
//                   }
//                   let htmlToInsert = productMiniItems.join('');
//                   editBoxItem.innerHTML = htmlToInsert;
//                   document.querySelectorAll(".js-remove-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removesecondStepItem.bind(this, index), true));
                 
//               })
//               .catch(error => {
//                   console.error('Error fetching or processing data:', error);
//               });
//               toolBarItems.forEach((ele)=>{
//                 if(ele.classList.contains("hidden") == true){
//                     ele.innerHTML = "";
//                 }
//               })
          

//       },
//       selectSecondStep: function(event) {
//           const _this = this;
//           const productHandle = event.target.closest(".js-second-step-product").getAttribute("data-second-step-product-handle");
//           const productCount = parseInt(localStorage.getItem("first-product-count"));
//           const toolBarItems = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
//           const productTitle = event.target.closest(".js-second-step-product").getAttribute("data-product-title");
//           _this.stepCount = parseInt(this.stepTwoElement.getAttribute("data-step"));
//           const editBoxItem = document.querySelector(".js-box-item");
          
//           let fetchPromises = [];
//           let result = '';
//           const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//           const charactersLength = characters.length;
//           let counter = 0;
//           while (counter < 4) {
//               result += characters.charAt(Math.floor(Math.random() * charactersLength));
//               counter += 1;
//           }
//           // console.log(productCount)
//         //   if (_this.stepTwoProducts.length < parseInt(productCount) && _this.stepTwoProducts.indexOf(_this.stepTwoProducts) == -1) {
//         //       _this.stepTwoProducts.push({ id: result, handle: productHandle });
//         //   }
//         if (_this.stepTwoProducts.length < parseInt(productCount)) {

//             const boxItem = event.target.closest(".box-item");
//             const inventoryQty = parseInt(boxItem.getAttribute("inventory-quantity")) || 0;

//             // Count how many times this product already added
//             const currentCount = _this.stepTwoProducts.filter(p => p.handle === productHandle).length;

//             if (currentCount >= inventoryQty) {

//                 const button = event.target.closest(".js-second-step-product");
//                 button.setAttribute("disabled", "");
//                 button.setAttribute("inventory_sold", "true");
//                 button.classList.add("sold-out");

//                 button.querySelector(".text").textContent = "Sold Out";

//                 const notificationUl = event.target.closest(".box-item").querySelector(".js-notification-ul");
//                 if (notificationUl) {
//                     notificationUl.insertAdjacentHTML("beforeend", `<li>Max quantity added</li>`);
//                     setTimeout(() => {
//                         const li = notificationUl.querySelector("li");
//                         if (li) li.remove();
//                     }, 2000);
//                 }

//                 return; // STOP execution
//             }

//             _this.stepTwoProducts.push({ id: result, handle: productHandle });
//         }


//           // console.log(_this.stepTwoProducts)
//           localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

//           // ── Toolbar redraws INSTANTLY from cache — no fetch needed ──
//           _this._redrawToolbar();

//           for (let product of _this.stepTwoProducts) {
//               fetchPromises.push(
//                   fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
//                   .then(res => {
//                       if (!res.ok) {
//                           throw new Error(`HTTP error! Status: ${res.status}`);
//                       }
//                       return res.json();
//                   })
//                   .then(request => {
//                       if (!request || Object.keys(request).length === 0) {
//                           throw new Error('Empty response or invalid JSON');
//                       }
//                       return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };
//                   })
//                   .catch(error => {
//                       console.error(`Error fetching or processing product ${product}:`, error);
//                       return { id: null, html: '' }; // Return placeholder data to maintain sequence
//                   })
//               );
//           }
//           Promise.all(fetchPromises)
//               .then(results => {
//                   const productMiniItems = [];
//                   const imageItem = [];
//                   results = results.filter(result => result.id !== null);
                  
//                   for (let [i,productData] of results.entries()) {
//                       const { uid, id, title, image, price } = productData;
//                       // ── Update cache with real price from API ──
//                       const productHandle = _this.stepTwoProducts.find(p => p.id === uid)?.handle;
//                       if (productHandle && _this._imageCache[productHandle]) {
//                           _this._imageCache[productHandle].price = `$ ${(price / 100).toFixed(2)}`;
//                       }
//                       let currentProductHtml = `
//                       <div class="items-list" data-id="${id}">
//                         <div class="items-list__item">
//                           <div class="item-image">
//                             <img src="${image}" alt="${title}">
//                           </div>
//                           <div class="item-title-remove">
//                             <h4>${title}</h4>
//                            <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
//                             <button class="delete-btn js-remove-item" data-remove-item="${uid}">Remove</button>
//                           </div>
//                         </div>
//                       </div>`;
                     
//                       productMiniItems.push(currentProductHtml);
//                       // toolbar already redrawn instantly above — no insertAdjacentHTML here
//                   }
//                   let htmlToInsert = productMiniItems.join('');
//                   editBoxItem.innerHTML = htmlToInsert;
                  
//                   document.querySelectorAll(".js-remove-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removesecondStepItem.bind(this, index), true));
//                   // setTimeout(()=>{
//                   //   document.querySelectorAll(".js-remove-item").forEach((removeButton,index) => removeButton.addEventListener("click",_this.removesecondStepItem.bind(this,index),true) );
//                   // },3000);
//               })
//               .catch(error => {
//                   console.error('Error fetching or processing data:', error);
//               });
             
//           if (_this.stepTwoProducts.length < parseInt(productCount)) {

//               const targetBoxItem = event.target.closest(".box-item") ||
//                   document.querySelector(`.box-item .js-second-step-product[data-second-step-product-handle="${productHandle}"]`)?.closest(".box-item");
//               const notificationUl = targetBoxItem ? targetBoxItem.querySelector(".js-notification-ul") : null;
//               if (notificationUl) {
//                   notificationUl.insertAdjacentHTML("beforeend", `<li>Create Your Own ${productTitle} added to box</li>`);
//                   setTimeout(() => {
//                       const li = notificationUl.querySelector("li");
//                       if (li) li.remove();
//                   }, 1500);
//               }

//           }
//           if (_this.stepTwoProducts.length === parseInt(productCount)) {
//             //   document.querySelector(".js-next-button").removeAttribute("disabled");
//              document.querySelector(".js-complete-button").removeAttribute("disabled");
//               document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
//                   thirdStepButton.removeAttribute("disabled");
//               });
//             //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
//             //       forthStepButton.removeAttribute("disabled");
//             //   });
//               _this._showFullNotification();
//           }
//         if(event.target.closest(".js-product-modal")){

//           event.target.closest(".js-product-modal").classList.add("hidden");
//            document.querySelector("body").classList.remove("popup-open");
//         }

//           // Update qty display counter after adding
//           _this._updateQtyDisplay(productHandle);

//           // Sync + button disabled state based on inventory
//           _this._syncAllButtonsForHandle(productHandle, true);

//           //  this.loadFromMemory();

//       },
//       nextStep: function(event) {
//           const _this = this;
//           _this.stepCount = _this.stepCount + 1;
//           console.log(event,_this.stepCount)

//           if (_this.stepCount === 2) {

//               _this.stepTwoElement.classList.remove("hidden");
//               _this.stepOneElement.classList.add("hidden");

//           }
//           if (_this.stepCount === 3) {
//               _this.stepTwoElement.classList.add("hidden");
//               _this.stepThreeElement.classList.remove("hidden");
//               _this.stepCount = _this.stepCount - 1;
//               event.target.classList.add("hidden");
//               document.querySelector(".js-complete-button").classList.remove("hidden");
//           }
//           if(_this.stepCount === 4){
//             _this.stepTwoElement.classList.add("hidden");
//             _this.stepThreeElement.classList.remove("hidden");
//             _this.stepCount = _this.stepCount - 2;
//             event.target.classList.add("hidden");
//             document.querySelector(".js-complete-button").classList.remove("hidden");
//           }
//           const productCount = parseInt(localStorage.getItem("first-product-count"));
//           if (_this.stepTwoProducts.length > productCount) {
//               _this.stepTwoProducts.splice([_this.stepTwoProducts.length - 1], 1);
//           }
//           localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));
//           if (_this.stepTwoProducts.length === productCount) {
//             //   document.querySelector(".js-next-button").removeAttribute("disabled");
//              document.querySelector(".js-complete-button").removeAttribute("disabled");
//               document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
//                   thirdStepButton.removeAttribute("disabled");
//               });
//             //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
//             //       forthStepButton.removeAttribute("disabled");
//             //   });
//           }

//       },
//       selectThirdStep: function(event) {
//           const _this = this;
//           const productHandle = event.target.closest(".js-third-step-product").getAttribute("data-third-step-product-handle");
//           const productTitle = event.target.closest(".js-third-step-product").getAttribute("data-product-title");
//           const extraBoxItem = document.querySelector(".js-extra-item");
//           _this.stepCount = parseInt(this.stepThreeElement.getAttribute("data-step"));
//           let fetchPromises = [];
          
//           const targetBoxItemThird = event.target.closest(".box-item");
//           const notificationUlThird = targetBoxItemThird ? targetBoxItemThird.querySelector(".js-notification-ul") : null;
//           if (notificationUlThird) {
//               notificationUlThird.insertAdjacentHTML("beforeend", `<li>${productTitle} added to box</li>`);
//               setTimeout(() => {
//                   const li = notificationUlThird.querySelector("li");
//                   if (li) li.remove();
//               }, 1500);
//           }
//           if (_this.stepThreeProducts.length > 0) {
//               document.querySelectorAll(".js-extra-main").forEach((ele) => {
//                   ele.classList.remove("hidden");
//               })
//           } 
//           let result = '';
//           const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//           const charactersLength = characters.length;
//           let counter = 0;
//           while (counter < 4) {
//               result += characters.charAt(Math.floor(Math.random() * charactersLength));
//               counter += 1;
//           }
//           _this.stepThreeProducts.push({ id: result, handle: productHandle });
//          localStorage.setItem("third-step-product", JSON.stringify(_this.stepThreeProducts));
//           for (let product of _this.stepThreeProducts) {
//               fetchPromises.push(
//                   fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
//                   .then(res => {
//                       if (!res.ok) {
//                           throw new Error(`HTTP error! Status: ${res.status}`);
//                       }
//                       return res.json();
//                   })
//                   .then(request => {
//                       if (!request || Object.keys(request).length === 0) {
//                           throw new Error('Empty response or invalid JSON');
//                       }
//                     return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };
                           
                    
//                   })
//                   .catch(error => {
//                       console.error(`Error fetching or processing product ${product}:`, error);
//                       return { id: null, html: '' }; // Return placeholder data to maintain sequence
//                   })
//               );

//           }
//           Promise.all(fetchPromises)
//               .then(results => {
//                   const productMiniItems = [];
//                   const imageItem = [];
//                   results = results.filter(result => result.id !== null);
                  
//                   for (let [i,productData] of results.entries()) {
//                       const { uid, id, title, image, price } = productData;
//                       let currentProductHtml = `
//                        <div class="items-list">
//                             <div class="items-list__item">
//                               <div class="item-image">
//                                 <img src="${image}" alt="${title}">
//                               </div>
//                               <div class="item-title-remove">
//                                 <h4>${title}</h4>
//                                <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
//                                 <button class="delete-btn js-remove-extra-item" data-remove-item="${uid}">Remove</button>
//                               </div>
//                             </div>
//                           </div>`;
                     
//                       productMiniItems.push(currentProductHtml);
                      
                     
//                   }
//                   let htmlToInsert = productMiniItems.join('');
//                   extraBoxItem.innerHTML = htmlToInsert;
                  
//                   document.querySelectorAll(".js-remove-extra-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removeThirdStepItem.bind(this, index), true));
                  
//               })
//               .catch(error => {
//                   console.error('Error fetching or processing data:', error);
//               });
//         if(event.target.closest(".js-product-third-modal")){
          
//           event.target.closest(".js-product-third-modal").classList.add("hidden");
//            document.querySelector("body").classList.remove("popup-open");
//         }
//       },
//     completeBox: function(event) {
//             const _this = this;

//             requestAnimationFrame(() => {
//                 _this.stepOneElement.classList.add("hidden");
//                 _this.stepTwoElement.classList.add("hidden");
//                 _this.stepThreeElement.classList.add("hidden");
//                 _this.stepThreeElement.classList.remove("hidden");
//                 document.querySelector(".js-toolbar").classList.add("hidden");
//             });

//             _this.stepCount = 3;

//             const boxItemForStepFour = document.querySelector(".js-box-item-step-four");
//             const priceElement = document.querySelector(".js-total-price");

//             priceElement.textContent = '$ 0.00';

//             // 👉 SHOW LOADING
//             boxItemForStepFour.innerHTML = `
//         <div class="box-loading js-box-loading">
//             <svg class="box-loading__spinner" width="32" height="32" viewBox="0 0 50 50">
//             <circle
//                 cx="25"
//                 cy="25"
//                 r="20"
//                 fill="none"
//                 stroke-width="5"
//                 stroke="#000"
//                 stroke-linecap="round"
//                 stroke-dasharray="31.4 31.4"
//             >
//                 <animateTransform
//                 attributeName="transform"
//                 type="rotate"
//                 from="0 25 25"
//                 to="360 25 25"
//                 dur="1s"
//                 repeatCount="indefinite"
//                 />
//             </circle>
//             </svg>
//             <span class="box-loading__text">Loading products…</span>
//         </div>
//         `;

//             Promise.all(
//                 _this.stepTwoProducts.map(product =>
//                     fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
//                         .then(res => res.ok ? res.json() : null)
//                         .then(request => request ? {
//                             uid: product.id,
//                             id: request.id,
//                             title: request.title,
//                             image: request.featured_image,
//                             price: request.price
//                         } : null)
//                         .catch(() => null)
//                 )
//             )
//             .then(results => {
//                 const validResults = results.filter(Boolean);

//                 // 👉 REMOVE LOADING
//                 const loader = boxItemForStepFour.querySelector(".js-box-loading");
//                 if (loader) loader.remove();

//                 if (validResults.length === 0) {
//                     priceElement.textContent = '$ 0.00';
//                     boxItemForStepFour.innerHTML = '';
//                     return;
//                 }

//                 const boxTotal = validResults.reduce((sum, p) => sum + p.price, 0);
//                 localStorage.setItem("box-total-price", boxTotal);

//                 boxItemForStepFour.innerHTML = validResults.map(({ uid, id, title, image, price }) =>
//                     `<div class="box-items__item" data-id="${id}">
//                         <div class="item-image">
//                             <img src="${image}" alt="${title}" width="40" height="40">
//                         </div>
//                         <div class="item-info">
//                             <div class="item-info__title">${title}</div>
//                             <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
//                             <div class="item-info__actions">
//                                 <button
//                                 type="button"
//                                 class="delete-btn js-box-item-remove-four"
//                                 data-remove-item="${uid}">
//                                 Remove
//                                 </button>
//                             </div>
//                         </div>
//                     </div>`
//                 ).join('');

//                 priceElement.textContent = '$ ' + (boxTotal / 100).toFixed(2);

//                 boxItemForStepFour.addEventListener("click", function(e) {
//                     if (e.target.classList.contains("js-box-item-remove-four")) {
//                         const index = Array
//                             .from(boxItemForStepFour.querySelectorAll(".js-box-item-remove-four"))
//                             .indexOf(e.target);

//                         _this.removeBoxItemForStepFour(index, e);
//                     }
//                 });
//             })
//             .catch(error => {
//                 console.error('Error:', error);

//                 // 👉 ENSURE LOADING IS REMOVED ON ERROR
//                 const loader = boxItemForStepFour.querySelector(".js-box-loading");
//                 if (loader) loader.remove();

//                 priceElement.textContent = '$ 0.00';
//             });
//         },


//       editBox: function(event) {
//           const _this = this;
//           const addedProduct = JSON.parse(localStorage.getItem("second-step-product")) || [];
//           const extraProduct = JSON.parse(localStorage.getItem("third-step-product")) || [];
          
//           if (addedProduct.length > 0) {
//               const editBoxItem = document.querySelector(".js-box-item");
              
//               // 👉 SHOW LOADING IMMEDIATELY
//               editBoxItem.innerHTML = `
//                   <div class="box-loading js-edit-loading">
//                       <svg class="box-loading__spinner" width="32" height="32" viewBox="0 0 50 50">
//                           <circle
//                               cx="25"
//                               cy="25"
//                               r="20"
//                               fill="none"
//                               stroke-width="5"
//                               stroke="#000"
//                               stroke-linecap="round"
//                               stroke-dasharray="31.4 31.4"
//                           >
//                               <animateTransform
//                                   attributeName="transform"
//                                   type="rotate"
//                                   from="0 25 25"
//                                   to="360 25 25"
//                                   dur="1s"
//                                   repeatCount="indefinite"
//                               />
//                           </circle>
//                       </svg>
//                       <span class="box-loading__text">Loading your items…</span>
//                   </div>
//               `;
              
//               // Show popup with loading state
//               this.editModelElement.classList.remove("hidden");
//               document.querySelector("body").classList.add("popup-open");
              
//               // 👉 FETCH PRODUCTS LIKE IN completeBox
//               let fetchPromises = [];
//               for (let product of _this.stepTwoProducts) {
//                   fetchPromises.push(
//                       fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
//                       .then(res => {
//                           if (!res.ok) {
//                               throw new Error(`HTTP error! Status: ${res.status}`);
//                           }
//                           return res.json();
//                       })
//                       .then(request => {
//                           if (!request || Object.keys(request).length === 0) {
//                               throw new Error('Empty response or invalid JSON');
//                           }
//                           return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };
//                       })
//                       .catch(error => {
//                           console.error(`Error fetching or processing product ${product}:`, error);
//                           return { id: null, html: '' };
//                       })
//                   );
//               }
              
//               Promise.all(fetchPromises)
//                   .then(results => {
//                       const productMiniItems = [];
//                       results = results.filter(result => result.id !== null);
                      
//                       for (let [i, productData] of results.entries()) {
//                           const { uid, id, title, image, price } = productData;
//                           let currentProductHtml = `
//                           <div class="items-list" data-id="${id}">
//                               <div class="items-list__item">
//                                   <div class="item-image">
//                                       <img src="${image}" alt="${title}">
//                                   </div>
//                                   <div class="item-title-remove">
//                                       <h4>${title}</h4>
//                                       <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
//                                       <button class="delete-btn js-remove-item" data-remove-item="${uid}">Remove</button>
//                                   </div>
//                               </div>
//                           </div>`;
//                           productMiniItems.push(currentProductHtml);
//                       }
                      
//                       let htmlToInsert = productMiniItems.join('');
                      
//                       // 👉 REMOVE LOADING and show content
//                       const loader = editBoxItem.querySelector(".js-edit-loading");
//                       if (loader) loader.remove();
                      
//                       editBoxItem.innerHTML = htmlToInsert;
                      
//                       // Re-attach Remove listeners
//                       document.querySelectorAll(".js-remove-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removesecondStepItem.bind(_this, index), true));
//                   })
//                   .catch(error => {
//                       console.error('Error fetching or processing data:', error);
                      
//                       // 👉 REMOVE LOADING on error
//                       const loader = editBoxItem.querySelector(".js-edit-loading");
//                       if (loader) loader.remove();
                      
//                       editBoxItem.innerHTML = '<p>Error loading products. Please try again.</p>';
//                   });
//           }
//       },
//       closeModel: function(event) {
//           this.editModelElement.classList.add("hidden");
//           document.querySelector("body").classList.remove("popup-open");
//       },
//       removesecondStepItem: function(buttonIndex, event) {
//           // console.log(event)
//           const _this = this;
//           const toolbar = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");

//           const currentUniqueId = event.currentTarget.getAttribute("data-remove-item");
//           // ── Get the handle BEFORE filtering so _updateQtyDisplay works correctly ──
//           const removedProduct = _this.stepTwoProducts.find((product) => product.id == currentUniqueId);
//           const removedHandle = removedProduct ? removedProduct.handle : null;
//           _this.stepTwoProducts = _this.stepTwoProducts.filter((product) => product.id != currentUniqueId);

//         if (removedHandle) {
//             // re-enable is handled below by _syncAllButtonsForHandle
//         }
//           // console.log(_this.stepTwoProducts)
//           // const newRemovedValue  = _this.stepTwoProducts.filter(item => item.ItemIndex !== variant.ItemIndex);
//           localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

//             // re-enable is handled below by _syncAllButtonsForHandle
//           if (_this.stepTwoProducts.indexOf(buttonIndex) == -1) {
//               event.target.closest(".items-list").remove();
//           }

//           // ── Redraw toolbar correctly from current stepTwoProducts array ──
//           _this._redrawToolbar();

//           _this.stepTwoElement.classList.remove("hidden");
//           _this.stepThreeElement.classList.add("hidden");
//         //   document.querySelector(".js-next-button").classList.remove("hidden");
//         //   document.querySelector(".js-next-button").setAttribute("disabled", "");
//           document.querySelector(".js-complete-button").setAttribute("disabled", "");
//           document.querySelectorAll(".js-step-3-button").forEach((ele) => {
//               ele.setAttribute("disabled", "");
//           })

//           // Update qty display after removing via sidebar Remove button
//           if (removedHandle) {
//               _this._updateQtyDisplay(removedHandle);
//               // Sync + button state (re-enable if inventory allows)
//               _this._syncAllButtonsForHandle(removedHandle);
//           }

//           /// check the index of array and li 


//       },
//       removeThirdStepItem: function(buttonIndex, event) {
//           const _this = this;
//           const currentUniqueId = event.currentTarget.getAttribute("data-remove-item");
//           _this.stepThreeProducts = _this.stepThreeProducts.filter((product) => product.id != currentUniqueId)
//           localStorage.setItem("third-step-product", JSON.stringify(_this.stepThreeProducts));
//           if (_this.stepThreeProducts.indexOf(buttonIndex) == -1) {
//               event.target.closest(".items-list").remove();
//           }
//           if (_this.stepThreeProducts.length == 0) {
//               document.querySelectorAll(".js-extra-main").forEach((elem) => {
//                   elem.classList.add("hidden");
//               });
//           }
//       },
//       removeExtraItemStepFour: function(buttonIndex, event) {
//           const _this = this;
//           const currentUniqueId = event.currentTarget.getAttribute("data-remove-item");
//          _this.stepThreeProducts = _this.stepThreeProducts.filter((product) => product.id != currentUniqueId)
//           localStorage.setItem("third-step-product", JSON.stringify(_this.stepThreeProducts));

//           if (_this.stepThreeProducts.indexOf(buttonIndex) == -1) {
//               event.target.closest(".box-items__item").remove();
//           }
//           if (_this.stepThreeProducts.length == 0) {
//             //   document.querySelector(".js-extra-item-main").classList.add("hidden");
//             //   document.querySelector(".js-extra-item").querySelectorAll(".items-list")[buttonIndex].remove();
//           }
//           const extraItemForStepFour = document.querySelector(".js-extra-item-step-four");
//           let fetchPromisesExtraItem = [];
//           let extraProductPrice = [];
//           if (_this.stepThreeProducts.length === 0) {
//               let mainProductPrice = parseInt(localStorage.getItem("box-total-price"));
//               document.querySelector(".js-total-price").innerHTML = '$ ' + (mainProductPrice/100).toFixed(2);
//           } else {

//             //   document.querySelector(".js-extra-item-main").classList.remove("hidden");
//               if (_this.stepThreeProducts.length > 0) {

//                   for (let product of _this.stepThreeProducts) {
//                       fetchPromisesExtraItem.push(
//                           fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
//                           .then(res => {
//                               if (!res.ok) {
//                                   throw new Error(`HTTP error! Status: ${res.status}`);
//                               }
//                               return res.json();
//                           })
//                           .then(request => {
//                               if (!request || Object.keys(request).length === 0) {
//                                   throw new Error('Empty response or invalid JSON');
//                               }
                          

//                               extraProductPrice.push((request.price))
//                               let mainProductPrice = parseInt(localStorage.getItem("box-total-price"));
//                               let totalPrice = 0;
//                               for (let allPrice of extraProductPrice) {
//                                   // mainProductPrice += allPrice;
//                                   totalPrice = totalPrice + allPrice
//                               }

//                               document.querySelector(".js-total-price").innerHTML = '$ ' + ((totalPrice + mainProductPrice)/100).toFixed(2)  ;


//                           })
//                           .catch(error => {
//                               console.error(`Error fetching or processing product ${product}:`, error);
//                               return { id: null, html: '' }; // Return placeholder data to maintain sequence
//                           })
//                       );

//                   }
//               }
//           }


//       },
//     removeBoxItemForStepFour: function(buttonIndex, event) {

//         const _this = this;

//         const button = event.target.closest(".js-box-item-remove-four");
//         if (!button) return;

//         const currentUniqueId = button.getAttribute("data-remove-item");
//         const toolbar = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
//         // 1️⃣ Remove correct product from array
//         _this.stepTwoProducts = _this.stepTwoProducts.filter(product => product.id !== currentUniqueId);

//         // 2️⃣ Update localStorage
//         localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

//         // 3️⃣ Remove correct DOM element
//         const itemElement = button.closest(".box-items__item");
//         if (itemElement) itemElement.remove();

//         // 4️⃣ If no products left → go back to Step 2
//        if (event.target.closest(".items-list") && _this.stepTwoProducts.indexOf(buttonIndex) == -1) {
//               event.target.closest(".items-list").remove();
//           }

//           // ── Redraw toolbar correctly from current stepTwoProducts array ──
//           _this._redrawToolbar();

//           _this.stepTwoElement.classList.remove("hidden");
//            _this.stepThreeElement.classList.add("hidden");
//         //   _this.stepFourElement.classList.add("hidden");
//         //   document.querySelector(".js-next-button").classList.remove("hidden");
//         //   document.querySelector(".js-next-button").setAttribute("disabled", "");
//           document.querySelector(".js-complete-button").setAttribute("disabled", "");
//           this.giftBoxToolBar.classList.remove("hidden");
//         // 5️⃣ Recalculate total
//         Promise.all(
//             _this.stepTwoProducts.map(product =>
//                 fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
//                     .then(res => res.ok ? res.json() : null)
//                     .catch(() => null)
//             )
//         ).then(results => {

//             const valid = results.filter(Boolean);

//             const newTotal = valid.reduce((sum, p) => sum + p.price, 0);

//             localStorage.setItem("box-total-price", newTotal);

//             const priceElement = document.querySelector(".js-total-price");
//             if (priceElement) {
//                 priceElement.textContent = '$ ' + (newTotal / 100).toFixed(2);
//             }

//         });

//         // 6️⃣ Refresh inventory state
//         _this.refreshStepTwoInventoryState();

//         // 7️⃣ Update qty display counters
//         _this._updateQtyDisplay();
//     },

//     // ── Helper: instantly rebuild the edit popup item list from cache (no fetch needed) ──
//     _rebuildEditPopup: function() {
//         const _this = this;
//         const editBoxItem = document.querySelector(".js-box-item");
//         if (!editBoxItem) return;

//         if (_this.stepTwoProducts.length === 0) {
//             editBoxItem.innerHTML = "";
//             return;
//         }

//         const html = _this.stepTwoProducts.map((product) => {
//             const cached = _this._imageCache[product.handle] || {};
//             const src   = cached.src   || "";
//             const title = cached.title || product.handle;
//             const price = cached.price || "";
//             return `<div class="items-list">
//                 <div class="items-list__item">
//                     <div class="item-image">
//                         <img src="${src}" alt="${title}">
//                     </div>
//                     <div class="item-title-remove">
//                         <h4>${title}</h4>
//                         <span class="item-price">${price}</span>
//                         <button class="delete-btn js-remove-item" data-remove-item="${product.id}">Remove</button>
//                     </div>
//                 </div>
//             </div>`;
//         }).join("");

//         editBoxItem.innerHTML = html;

//         // Re-attach Remove listeners
//         editBoxItem.querySelectorAll(".js-remove-item").forEach((btn, index) => {
//             btn.addEventListener("click", _this.removesecondStepItem.bind(_this, index), true);
//         });
//     },

//     // ── Helper: sync BOTH the qty+ button AND the add-to-box button for a given handle ──
//     _syncAllButtonsForHandle: function(handle, showNotification) {
//         const _this = this;
//         document.querySelectorAll(".box-item").forEach((boxItem) => {
//             const addBtn = boxItem.querySelector(".js-second-step-product[data-second-step-product-handle]");
//             if (!addBtn) return;
//             if (addBtn.getAttribute("data-second-step-product-handle") !== handle) return;

//             const inventoryQty = parseInt(boxItem.getAttribute("inventory-quantity")) || 0;
//             const currentCount = _this.stepTwoProducts.filter(p => p.handle === handle).length;

//             // Target both buttons inside this box-item with this handle
//             const qtyPlusBtn  = boxItem.querySelector(".qty-btn--plus");
//             const addToBoxBtn = boxItem.querySelector(".btn--add-to-box.js-second-step-product");

//             if (currentCount >= inventoryQty) {
//                 // ── Disable qty + button ──
//                 if (qtyPlusBtn) {
//                     qtyPlusBtn.setAttribute("disabled", "");
//                     qtyPlusBtn.setAttribute("inventory_sold", "true");
//                 }
//                 // ── Disable add-to-box button and show sold out ──
//                 if (addToBoxBtn) {
//                     addToBoxBtn.setAttribute("disabled", "");
//                     addToBoxBtn.setAttribute("inventory_sold", "true");
//                     addToBoxBtn.classList.add("sold-out");
//                     const textSpan = addToBoxBtn.querySelector(".text");
//                     if (textSpan) textSpan.textContent = "Sold Out";
//                 }
//                 // ── Show notification only when triggered by user action ──
//                 if (showNotification) {
//                     const notificationUl = boxItem.querySelector(".js-notification-ul");
//                     if (notificationUl && !notificationUl.querySelector("li")) {
//                         notificationUl.insertAdjacentHTML("beforeend", `<li>Max quantity added</li>`);
//                         setTimeout(() => {
//                             const li = notificationUl.querySelector("li");
//                             if (li) li.remove();
//                         }, 2000);
//                     }
//                 }
//             } else {
//                 // ── Re-enable qty + button ──
//                 if (qtyPlusBtn) {
//                     qtyPlusBtn.removeAttribute("disabled");
//                     qtyPlusBtn.removeAttribute("inventory_sold");
//                 }
//                 // ── Re-enable add-to-box button ──
//                 if (addToBoxBtn) {
//                     addToBoxBtn.removeAttribute("disabled");
//                     addToBoxBtn.removeAttribute("inventory_sold");
//                     addToBoxBtn.classList.remove("sold-out");
//                     const textSpan = addToBoxBtn.querySelector(".text");
//                     if (textSpan) textSpan.textContent = "Add to box";
//                 }
//             }
//         });
//     },

//     // ── Helper: show "box is full" notification in .js-notification-ul-full ──
//     _showFullNotification: function() {
//         const ul = document.querySelector(".js-notification-ul-full");
//         if (!ul) return;
//         // Clear any existing message first to avoid stacking
//         ul.innerHTML = "";
//         ul.insertAdjacentHTML("beforeend", "<li>Your Gift Box is full!</li>");
//         setTimeout(() => {
//             const li = ul.querySelector("li");
//             if (li) li.remove();
//         }, 2500);
//     },

//     // ── Helper: instantly redraw all toolbar li images from stepTwoProducts + imageCache ──
//     _redrawToolbar: function() {
//         const toolBarItems = this.giftBoxToolBar
//             .querySelector(".js-toolbar-item")
//             .querySelectorAll("li");

//         toolBarItems.forEach((li, index) => {
//             // Only touch visible (non-hidden) slots
//             if (li.classList.contains("hidden")) {
//                 li.innerHTML = "";
//                 return;
//             }
//             const product = this.stepTwoProducts[index];
//             if (product) {
//                 const cached = this._imageCache[product.handle];
//                 if (cached) {
//                     li.innerHTML = `<img src="${cached.src}" alt="${cached.alt}" data-handle="${product.id}">`;
//                 }
//                 // if no cache entry yet, leave existing content (edge case)
//             } else {
//                 // slot is empty — clear it
//                 li.innerHTML = "";
//             }
//         });
//     },

//     // ── Helper: update qty display badge for one handle (or all if no handle given) ──
//     _updateQtyDisplay: function(handle) {
//         const _this = this;
//         document.querySelectorAll(".box-item").forEach((boxItem) => {
//             const btn = boxItem.querySelector(".js-second-step-product");
//             if (!btn) return;

//             const itemHandle = btn.getAttribute("data-second-step-product-handle");

//             // If a specific handle is given, only update that card
//             if (handle !== undefined && itemHandle !== handle) return;

//             const count = _this.stepTwoProducts.filter(p => p.handle === itemHandle).length;
//             const display = boxItem.querySelector(".js-qty-display");
//             const minusBtn = boxItem.querySelector(".js-qty-minus");

//             if (display) display.textContent = count;
//             if (minusBtn) minusBtn.disabled = count === 0;
//         });
//     },

//     addToGiftBox: function(event) {
//         const _this = this;
//         const giftMessageValue = this.giftMessageElement.value;
//         const mainProduct = localStorage.getItem("first-step-product");
        
//         // Generate unique bundle ID
//         const uniqueBundleId = Date.now().toString();
        
//         const property = {
//             "Gift Message": giftMessageValue,
//             "unique_id": "main_product"
//         };
        
//         // Disable button and add loading state
//         _this.addToGiftButtonElement.setAttribute("disabled", "");
//         const originalButtonText = _this.addToGiftButtonElement.innerHTML;
//         _this.addToGiftButtonElement.innerHTML = '<span class="loading-spinner"></span> Adding...';
        
//         let deliveryOption;
//         _this.deliveryOptionElements.forEach((option) => {
//             if (option.checked === true) {
//                 deliveryOption = option.value;
//             }
//         });

//         const formData1 = {
//             items: []
//         };

//         const formData2 = {
//             items: []
//         };

//         let boxProduct = [];
//         let extProduct = [];

//         const allProductOfBox = [];
//         const allProductOfExtra = [];
        
//         // Process main product (the gift box itself)
//         const processMainProduct = () => {
//             if (mainProduct) {
//                 return fetch(`${window.Shopify.routes.root}products/${mainProduct}.js`)
//                     .then(res => res.json())
//                     .then(request => {
//                         const mainProductItem = {
//                             id: request.variants[0].id,
//                             quantity: 1,
//                             properties: { 
//                                 "Gift Message": giftMessageValue, 
//                                 "Delivery Option": deliveryOption,
//                                 "unique_id": "main_product",
//                                 "_bundleId": uniqueBundleId
//                             }
//                         };
//                         return fetch(window.Shopify.routes.root + 'cart/add.js', {
//                             method: 'POST',
//                             headers: {
//                                 'Content-Type': 'application/json'
//                             },
//                             body: JSON.stringify({ items: [mainProductItem] })
//                         }).then(response => response.json());
//                     })
//                     .catch(error => {
//                         console.error('Error adding main product:', error);
//                         return Promise.resolve();
//                     });
//             } else {
//                 return Promise.resolve();
//             }
//         };

//         const processBoxProducts = () => {
//             if (_this.stepTwoProducts.length === allProductOfBox.length && boxProduct.length > 0) {
//                 const counts = {};
//                 allProductOfBox.forEach(x => counts[x] = (counts[x] || 0) + 1);
//                 const boxProductSummary = Object.entries(counts).map(([title, count]) => `${title}: ${count}`).join(', ');
//                 localStorage.setItem("boxProduct", JSON.stringify(boxProductSummary));
//                 formData1.items = boxProduct;
//                 return fetch(window.Shopify.routes.root + 'cart/add.js', {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify(formData1)
//                 }).then(response => response.json());
//             } else {
//                 return Promise.resolve();
//             }
//         };

//         const processExtraProducts = () => {
//             if (_this.stepThreeProducts.length === allProductOfExtra.length && extProduct.length > 0) {
//                 const counts = {};
//                 allProductOfExtra.forEach(x => counts[x] = (counts[x] || 0) + 1);
//                 const extraProductSummary = Object.entries(counts).map(([title, count]) => `${title}: ${count}`).join(', ');
//                 localStorage.setItem("extraProduct", JSON.stringify(extraProductSummary));
//                 formData2.items = extProduct;
//                 return fetch(window.Shopify.routes.root + 'cart/add.js', {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify(formData2)
//                 }).then(response => response.json());
//             } else {
//                 return Promise.resolve();
//             }
//         };

//         const fetchBoxProducts = _this.stepTwoProducts.map(boxItem => {
//             return fetch(`${window.Shopify.routes.root}products/${boxItem.handle}.js`)
//                 .then(res => res.json())
//                 .then(request => {
//                     allProductOfBox.push(request.title);
//                     boxProduct.push({
//                         id: request.variants[0].id,
//                         quantity: 1,
//                         properties: { 
//                             Message: giftMessageValue, 
//                             "Delivery Option": deliveryOption, 
//                             "Box item": true,
//                             "_bundleId": uniqueBundleId
//                         }
//                     });
//                 })
//                 .catch(error => console.error('Error fetching box product:', error));
//         });

//         const fetchExtraProducts = _this.stepThreeProducts.map(extraItem => {
//             return fetch(`${window.Shopify.routes.root}products/${extraItem.handle}.js`)
//                 .then(res => res.json())
//                 .then(request => {
//                     allProductOfExtra.push(request.title);
//                     extProduct.push({
//                         id: request.variants[0].id,
//                         quantity: 1,
//                         properties: { Message: giftMessageValue, "Delivery Option": deliveryOption, "Extra item": true }
//                     });
//                 })
//                 .catch(error => console.error('Error fetching extra product:', error));
//         });

//         // Add main product first, then box products, then extra products
//         processMainProduct()
//             .then(() => Promise.all([...fetchBoxProducts, ...fetchExtraProducts]))
//             .then(() => processBoxProducts())
//             .then(() => processExtraProducts())
//             .then(() => {
//                 // Remove loading state
//                 _this.addToGiftButtonElement.removeAttribute("disabled");
//                 _this.addToGiftButtonElement.innerHTML = originalButtonText;
                
//                 setTimeout(() => {
//                     window.location.href = window.Shopify.routes.root + 'cart';
//                 }, 500);
//             })
//             .catch(error => {
//                 console.error('Error:', error);
//                 // Remove loading state on error
//                 _this.addToGiftButtonElement.removeAttribute("disabled");
//                 _this.addToGiftButtonElement.innerHTML = originalButtonText;
//                 alert('There was an error adding items to cart. Please try again.');
//             });
//     }



//   }
//   giftBoxBuilder.init();
// })();


(function () {
    giftBoxBuilder = {
        selector: {
            firstStepBoxButton: '.js-your-box-button',
            toolbarElement: '.js-toolbar',
            stepOne: '.js-stage-1',
            stepTwo: '.js-stage-2',
            stepThree: '.js-stage-3',
            stepFour: '.js-stage-4',
            scondStepProducts: '.js-second-step-product',
            nextButton: '.js-next-button',
            completeButton: '.js-complete-button',
            editButton: '.js-edit-button',
            editModel: '.js-edit-model',
            thirdStepProducts: '.js-third-product-button',
            closeModel: '.js-close-model',
            totalPrice: '.js-total-price',
            giftMessage: '.js-gift-message',
            deliveryOption: '[name=delivery-option]',
            addToGiftButton: '.js-add-to-gift-button',
            changeBox: '.js-change-box',
            chnageBoxButton: '.js-change-your-box-button',
            productInfo: '.js-product-info',
            productThirdInfo: '.js-product-third-info'
        },
        init: function () {

            this.firstStepButtons = document.querySelectorAll(this.selector.firstStepBoxButton);
            this.giftBoxToolBar = document.querySelector(this.selector.toolbarElement);
            this.stepOneElement = document.querySelector(this.selector.stepOne);
            this.stepTwoElement = document.querySelector(this.selector.stepTwo);
            this.stepThreeElement = document.querySelector(this.selector.stepThree);
            this.stepFourElement = document.querySelector(this.selector.stepFour);
            this.secondStepProductButtons = document.querySelectorAll(this.selector.scondStepProducts);
            this.thirdStepProductButtons = document.querySelectorAll(this.selector.thirdStepProducts);
            //   this.nextButtonElement = document.querySelector(this.selector.nextButton);
            this.completeButtonElement = document.querySelector(this.selector.completeButton);
            this.editButtonElement = document.querySelector(this.selector.editButton);
            this.editModelElement = document.querySelector(this.selector.editModel);
            this.closeModelElement = document.querySelector(this.selector.closeModel);
            this.totalPriceElement = document.querySelector(this.selector.totalPrice);
            this.giftMessageElement = document.querySelector(this.selector.giftMessage);
            this.deliveryOptionElements = document.querySelectorAll(this.selector.deliveryOption);
            this.addToGiftButtonElement = document.querySelector(this.selector.addToGiftButton);
            this.changeBoxElement = document.querySelector(this.selector.changeBox);
            this.changeBoxButtonElement = document.querySelectorAll(this.selector.chnageBoxButton);
            this.productInfoElement = document.querySelectorAll(this.selector.productInfo);
            this.productThirdInfoElement = document.querySelectorAll(this.selector.productThirdInfo);
            this.boxProductArr = JSON.parse(localStorage.getItem("second-step-product")) || [];
            this.extProductArr = JSON.parse(localStorage.getItem("third-step-product")) || [];
            this.stepTwoProducts = [];
            this.stepThreeProducts = [];
            this.stepCount = 1;
            this.allProductPrice = [];

            // ── Image cache: build handle→src map from DOM immediately (no fetch needed for toolbar) ──
            this._imageCache = {};
            document.querySelectorAll(".box-item").forEach((boxItem) => {
                const btn = boxItem.querySelector(".js-second-step-product");
                if (!btn) return;
                const handle = btn.getAttribute("data-second-step-product-handle");
                if (!handle) return;
                // grab the first visible img in the card (already rendered by Liquid)
                const img = boxItem.querySelector("img");
                // grab price text already rendered by Liquid
                const priceEl = boxItem.querySelector(".box-item__price");
                const priceText = priceEl ? priceEl.textContent.trim() : "";
                const title = btn.getAttribute("data-product-title") || img?.alt || handle;
                if (img && img.src) {
                    this._imageCache[handle] = { src: img.src, alt: title, title: title, price: priceText };
                }
            });

            this.bindEvent();

        },
        bindEvent: function () {
            const _this = this
            // console.log(this.firstStepButtons)
            localStorage.removeItem("first-step-product");
            localStorage.removeItem("second-step-product");
            localStorage.removeItem("third-step-product");
            localStorage.removeItem("boxProduct");
            localStorage.removeItem("extraProduct");
            localStorage.removeItem("first-product-count");
            localStorage.removeItem("box-total-price");
            localStorage.removeItem("extra-total-price");

            this.stepFirstButton = this.firstStepButtons.forEach((firstStepButton) => firstStepButton.addEventListener("click", _this.toolBarEvent.bind(this), true));
            this.stepFirstButton = this.firstStepButtons.forEach((firstStepButton) => firstStepButton.addEventListener("click", _this.selectFirstStep.bind(this), true));
            this.stepSecondButtons = this.secondStepProductButtons.forEach((secondStepProductButton) => secondStepProductButton.addEventListener("click", _this.selectSecondStep.bind(this), true));
            this.stepThirdButtons = this.thirdStepProductButtons.forEach((thirdStepProductButton) => thirdStepProductButton.addEventListener("click", _this.selectThirdStep.bind(this), true));
            //   this.nextButtonElement.addEventListener("click", _this.nextStep.bind(this), true);
            this.completeButtonElement.addEventListener("click", _this.completeBox.bind(this), true);
            this.editButtonElement.addEventListener("click", _this.editBox.bind(this), true);
            this.closeModelElement.addEventListener("click", _this.closeModel.bind(this), true);
            this.addToGiftButtonElement.addEventListener("click", _this.addToGiftBox.bind(this), true);
            document.querySelectorAll(".js-change-your-box-button").forEach((changeStepButton) => changeStepButton.addEventListener("click", _this.selectFirstStep.bind(this), true));
            document.querySelectorAll(".js-change-your-box-button").forEach((changeStepButton) => changeStepButton.addEventListener("click", _this.toolBarEvent.bind(this), true));
            this.productInfoElement.forEach((item) => item.addEventListener("click", _this.openProductInfo.bind(this), true));
            this.productThirdInfoElement.forEach((item) => item.addEventListener("click", _this.openProductThirdInfo.bind(this), true))
            document.querySelectorAll(".js-close-button").forEach((close) => close.addEventListener("click", _this.closeProductInfo.bind(this), true));
            document.querySelectorAll(".js-close-third-button").forEach((close) => close.addEventListener("click", _this.closeProductThirdInfo.bind(this), true));

            // ── Quantity minus buttons ──────────────────────────────────────────
            document.querySelectorAll(".js-qty-minus").forEach((minusBtn) => {
                minusBtn.addEventListener("click", function (event) {
                    event.stopPropagation();

                    const boxItem = minusBtn.closest(".box-item");
                    const handle = boxItem
                        .querySelector(".js-second-step-product")
                        .getAttribute("data-second-step-product-handle");

                    // Find the last added product entry with this handle
                    const lastIndex = _this.stepTwoProducts
                        .map((p, i) => p.handle === handle ? i : -1)
                        .filter(i => i !== -1)
                        .pop();

                    if (lastIndex === undefined) return;

                    const uid = _this.stepTwoProducts[lastIndex].id;

                    // Remove from array
                    _this.stepTwoProducts.splice(lastIndex, 1);

                    // Update localStorage
                    localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

                    // ── Redraw toolbar instantly from cache ──
                    _this._redrawToolbar();

                    // Disable complete/next since box is now underfilled
                    document.querySelector(".js-complete-button").setAttribute("disabled", "");
                    document.querySelectorAll(".js-step-3-button").forEach(b => b.setAttribute("disabled", ""));

                    // Update qty display counter
                    _this._updateQtyDisplay(handle);

                    // Sync + button state (re-enable if inventory allows)
                    _this._syncAllButtonsForHandle(handle);

                    // Remove corresponding entry from the sidebar items list
                    const editBoxItem = document.querySelector(".js-box-item");
                    if (editBoxItem) {
                        editBoxItem.querySelectorAll(".items-list").forEach(el => {
                            if (el.querySelector(`[data-remove-item="${uid}"]`)) el.remove();
                        });
                    }
                });
            });
            // ───────────────────────────────────────────────────────────────────

            document.querySelectorAll(".js-step-2-button").forEach((secondStepButton) => {
                secondStepButton.addEventListener("click", function (event) {

                    if (secondStepButton.hasAttribute("disabled") === false) {
                        // Hide all steps first
                        _this.stepOneElement.classList.add("hidden");
                        _this.stepTwoElement.classList.add("hidden");
                        _this.stepThreeElement.classList.add("hidden");

                        // Show step 2
                        _this.stepTwoElement.classList.remove("hidden");
                        _this.stepCount = 2;

                        //   document.querySelector(".js-complete-button").classList.add("hidden");
                        document.querySelector(".js-toolbar").classList.remove("hidden");
                    }
                });
            });

            document.querySelectorAll(".js-step-1-button").forEach((firstStepButton) => {
                firstStepButton.addEventListener("click", function (event) {
                    // Hide all steps first
                    _this.stepOneElement.classList.add("hidden");
                    _this.stepTwoElement.classList.add("hidden");
                    _this.stepThreeElement.classList.add("hidden");

                    // Show step 1
                    _this.stepOneElement.classList.remove("hidden");
                    _this.stepCount = 1;

                    //   document.querySelector(".js-complete-button").classList.add("hidden");
                    document.querySelector(".js-toolbar").classList.add("hidden");
                });
            });


            document.querySelectorAll(".js-step-3-button").forEach((ThirdStepButton) => {
                ThirdStepButton.addEventListener("click", function (event) {
                    if (!this.hasAttribute("disabled")) {
                        _this.completeBox.call(_this, event);
                    }
                });
            });
            //   document.querySelectorAll(".js-step-4-button").forEach((fourStepButton) => {
            //       fourStepButton.addEventListener("click", _this.completeBox.bind(this))
            //   });
            this.changeBoxElement.addEventListener("click", function (event) {
                document.querySelector(".js-change-box-popup").classList.remove("hidden");
                document.querySelector("body").classList.add("popup-open");
            })
            document.querySelector(".js-change-popup-close").addEventListener("click", function () {
                document.querySelector(".js-change-box-popup").classList.add("hidden");
                document.querySelector("body").classList.remove("popup-open");

            });
            if (document.querySelector(".js-prev") || document.querySelector(".js-next")) {

                document.querySelector(".js-prev").addEventListener("click", function () {
                    document.querySelector(".gift-box-box-selector__box-list").classList.add("auto-scrolling");
                    setTimeout(() => {
                        document.querySelector(".gift-box-box-selector__box-list").classList.remove("auto-scrolling");
                    }, 100)
                })
                document.querySelector(".js-next").addEventListener("click", function () {
                    document.querySelector(".gift-box-box-selector__box-list").classList.add("auto-scrolling");
                    setTimeout(() => {
                        document.querySelector(".gift-box-box-selector__box-list").classList.remove("auto-scrolling");
                    }, 100)
                })
            }

        },

        toolBarEvent: function (event) {
            this.giftBoxToolBar.classList.remove("hidden");
            const productCount = event.target.closest(".js-box-product").getAttribute("data-product");
            this.giftBoxToolBar.querySelector(".js-current-selection").innerHTML = `Box Items: ${productCount}`;
            this.giftBoxToolBar.querySelector(".js-current-selection").setAttribute("data-product-count", productCount);
            const toolBarItems = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
            // console.log(productCount)
            toolBarItems.forEach((item, index) => {
                if (index >= parseInt(productCount)) {

                    item.classList.add("hidden");
                } else {

                    item.classList.remove("hidden");
                }
            });
            document.querySelector(".js-change-box-popup").classList.add("hidden");
        },
        openProductInfo: function (event) {
            event.target.closest(".box-item").querySelector(".js-product-modal").classList.remove("hidden");
            document.querySelector("body").classList.add("popup-open");
        },
        closeProductInfo: function (event) {
            event.target.closest(".js-product-modal").classList.add("hidden");
            document.querySelector("body").classList.remove("popup-open");
        },
        openProductThirdInfo: function (event) {
            // console.log(event.target)
            event.target.closest(".box-item").querySelector(".js-product-third-modal").classList.remove("hidden");
            document.querySelector("body").classList.add("popup-open");
        },
        closeProductThirdInfo: function (event) {
            event.target.closest(".js-product-third-modal").classList.add("hidden");
            document.querySelector("body").classList.remove("popup-open");
        },
        refreshStepTwoInventoryState: function () {

            const _this = this;

            // Collect unique handles from all second-step product buttons
            const handles = new Set();
            document.querySelectorAll(".js-second-step-product[data-second-step-product-handle]").forEach((btn) => {
                const handle = btn.getAttribute("data-second-step-product-handle");
                if (handle) handles.add(handle);
            });

            // Use unified helper to sync both qty+ and add-to-box buttons per handle
            handles.forEach((handle) => {
                _this._syncAllButtonsForHandle(handle, false);
            });

        },

        selectFirstStep: function (event) {
            // console.log(event)
            const _this = this;
            const firstStepProductHandle = event.target.getAttribute("data-product-handle");
            const productCountForStepOne = event.target.getAttribute("data-product-count");
            const toolBarItems = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
            const extraBoxItem = document.querySelector(".js-extra-item");
            localStorage.setItem("first-step-product", firstStepProductHandle);
            localStorage.setItem("first-product-count", productCountForStepOne);
            document.querySelector("body").classList.remove("popup-open");
            this.stepOneElement.classList.add("hidden");
            this.stepTwoElement.classList.remove("hidden");
            _this.refreshStepTwoInventoryState();
            this.stepThreeElement.classList.add("hidden");
            this.stepCount = this.stepCount + 1;
            let fetchPromises = [];
            const editBoxItem = document.querySelector(".js-box-item");
            document.querySelectorAll(".js-step-2-button").forEach((secondStepButton) => {
                secondStepButton.removeAttribute("disabled");
            });
            //   document.querySelector(".js-next-button").classList.remove("hidden");
            //   document.querySelector(".js-complete-button").classList.add("hidden");
            const productCount = parseInt(localStorage.getItem("first-product-count"));
            if (_this.stepTwoProducts.length > productCount) {
                toolBarItems.forEach((li, index) => {
                    if (li.querySelector("img") && index === _this.stepTwoProducts.length - 1) {

                        li.querySelector("img").remove();
                    }
                });
                if (productCount == parseInt(productCountForStepOne)) {
                    if (_this.stepTwoProducts.length > productCount) {
                        let deleteItem = _this.stepTwoProducts.length - productCount
                        _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);
                    } else {
                        let deleteItem = _this.stepTwoProducts.length - productCount
                        _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);
                    }
                }
                if (productCount == parseInt(productCountForStepOne)) {
                    let deleteItem = _this.stepTwoProducts.length - productCount
                    _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);

                }
                if (productCount == parseInt(productCountForStepOne)) {
                    let deleteItem = _this.stepTwoProducts.length - productCount
                    _this.stepTwoProducts.splice([_this.stepTwoProducts.length - deleteItem], deleteItem);
                }
            }
            console.log(productCount, _this.stepTwoProducts.length)
            localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

            // ── Redraw toolbar instantly from cache ──
            _this._redrawToolbar();

            // 👉 UPDATE ALL QUANTITY DISPLAYS after products are removed
            _this._updateQtyDisplay();

            if (_this.stepTwoProducts.length === productCount) {
                //   document.querySelector(".js-next-button").removeAttribute("disabled");
                document.querySelector(".js-complete-button").removeAttribute("disabled");
                document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
                    thirdStepButton.removeAttribute("disabled");
                });
                //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
                //       forthStepButton.removeAttribute("disabled");
                //   });
            } else {
                //   document.querySelector(".js-next-button").setAttribute("disabled", "");
                document.querySelector(".js-complete-button").setAttribute("disabled", "");
                document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
                    thirdStepButton.setAttribute("disabled", "");
                });
                //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
                //       forthStepButton.setAttribute("disabled", "");
                //   });
            }
            for (let product of _this.stepTwoProducts) {
                fetchPromises.push(
                    fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
                        .then(res => {
                            if (!res.ok) {
                                throw new Error(`HTTP error! Status: ${res.status}`);
                            }
                            return res.json();
                        })
                        .then(request => {
                            if (!request || Object.keys(request).length === 0) {
                                throw new Error('Empty response or invalid JSON');
                            }
                            return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };
                        })
                        .catch(error => {
                            console.error(`Error fetching or processing product ${product}:`, error);
                            return { id: null, html: '' }; // Return placeholder data to maintain sequence
                        })
                );

            }
            Promise.all(fetchPromises)
                .then(results => {
                    const productMiniItems = [];
                    const imageItem = [];
                    results = results.filter(result => result.id !== null);

                    for (let [i, productData] of results.entries()) {
                        const { uid, id, title, image, price } = productData;
                        let currentProductHtml = `<div class="items-list" data-id="${id}">
                          <div class="items-list__item">
                            <div class="item-image">
                              <img src="${image}" alt="${title}">
                            </div>
                            <div class="item-title-remove">
                              <h4>${title}</h4>
                              <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
                              <button class="delete-btn js-remove-item" data-remove-item="${uid}">Remove</button>
                            </div>
                          </div>
                        </div>`
                        productMiniItems.push(currentProductHtml);
                        // toolbar already redrawn instantly above — no insertAdjacentHTML here
                    }
                    let htmlToInsert = productMiniItems.join('');
                    editBoxItem.innerHTML = htmlToInsert;
                    document.querySelectorAll(".js-remove-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removesecondStepItem.bind(this, index), true));

                })
                .catch(error => {
                    console.error('Error fetching or processing data:', error);
                });
            toolBarItems.forEach((ele) => {
                if (ele.classList.contains("hidden") == true) {
                    ele.innerHTML = "";
                }
            })


        },
        selectSecondStep: function (event) {
            const _this = this;
            const productHandle = event.target.closest(".js-second-step-product").getAttribute("data-second-step-product-handle");
            const productCount = parseInt(localStorage.getItem("first-product-count"));
            const toolBarItems = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
            const productTitle = event.target.closest(".js-second-step-product").getAttribute("data-product-title");
            _this.stepCount = parseInt(this.stepTwoElement.getAttribute("data-step"));
            const editBoxItem = document.querySelector(".js-box-item");

            let fetchPromises = [];
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < 4) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            // console.log(productCount)
            //   if (_this.stepTwoProducts.length < parseInt(productCount) && _this.stepTwoProducts.indexOf(_this.stepTwoProducts) == -1) {
            //       _this.stepTwoProducts.push({ id: result, handle: productHandle });
            //   }
            if (_this.stepTwoProducts.length < parseInt(productCount)) {

                const boxItem = event.target.closest(".box-item");
                const inventoryQty = parseInt(boxItem.getAttribute("inventory-quantity")) || 0;

                // Count how many times this product already added
                const currentCount = _this.stepTwoProducts.filter(p => p.handle === productHandle).length;

                if (currentCount >= inventoryQty) {

                    const button = event.target.closest(".js-second-step-product");
                    button.setAttribute("disabled", "");
                    button.setAttribute("inventory_sold", "true");
                    button.classList.add("sold-out");

                    button.querySelector(".text").textContent = "Sold Out";

                    const notificationUl = event.target.closest(".box-item").querySelector(".js-notification-ul");
                    if (notificationUl) {
                        notificationUl.insertAdjacentHTML("beforeend", `<li>Max quantity added</li>`);
                        setTimeout(() => {
                            const li = notificationUl.querySelector("li");
                            if (li) li.remove();
                        }, 2000);
                    }

                    return; // STOP execution
                }

                _this.stepTwoProducts.push({ id: result, handle: productHandle });
            }


            // console.log(_this.stepTwoProducts)
            localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));
          
            _this._rebuildEditPopup();


            // ── Toolbar redraws INSTANTLY from cache — no fetch needed ──
            _this._redrawToolbar();

            // for (let product of _this.stepTwoProducts) {
            //     fetchPromises.push(
            //         fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
            //             .then(res => {
            //                 if (!res.ok) {
            //                     throw new Error(`HTTP error! Status: ${res.status}`);
            //                 }
            //                 return res.json();
            //             })
            //             .then(request => {
            //                 if (!request || Object.keys(request).length === 0) {
            //                     throw new Error('Empty response or invalid JSON');
            //                 }
            //                 return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };
            //             })
            //             .catch(error => {
            //                 console.error(`Error fetching or processing product ${product}:`, error);
            //                 return { id: null, html: '' }; // Return placeholder data to maintain sequence
            //             })
            //     );
            // }
            // Promise.all(fetchPromises)
            //     .then(results => {
            //         const productMiniItems = [];
            //         const imageItem = [];
            //         results = results.filter(result => result.id !== null);

            //         for (let [i, productData] of results.entries()) {
            //             const { uid, id, title, image, price } = productData;
            //             // ── Update cache with real price from API ──
            //             const productHandle = _this.stepTwoProducts.find(p => p.id === uid)?.handle;
            //             if (productHandle && _this._imageCache[productHandle]) {
            //                 _this._imageCache[productHandle].price = `$ ${(price / 100).toFixed(2)}`;
            //             }
            //             let currentProductHtml = `
            //           <div class="items-list" data-id="${id}">
            //             <div class="items-list__item">
            //               <div class="item-image">
            //                 <img src="${image}" alt="${title}">
            //               </div>
            //               <div class="item-title-remove">
            //                 <h4>${title}</h4>
            //                <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
            //                 <button class="delete-btn js-remove-item" data-remove-item="${uid}">Remove</button>
            //               </div>
            //             </div>
            //           </div>`;

            //             productMiniItems.push(currentProductHtml);
            //             // toolbar already redrawn instantly above — no insertAdjacentHTML here
            //         }
            //         let htmlToInsert = productMiniItems.join('');
            //         editBoxItem.innerHTML = htmlToInsert;

            //         document.querySelectorAll(".js-remove-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removesecondStepItem.bind(this, index), true));
            //         // setTimeout(()=>{
            //         //   document.querySelectorAll(".js-remove-item").forEach((removeButton,index) => removeButton.addEventListener("click",_this.removesecondStepItem.bind(this,index),true) );
            //         // },3000);
            //     })
            //     .catch(error => {
            //         console.error('Error fetching or processing data:', error);
            //     });

            if (_this.stepTwoProducts.length < parseInt(productCount)) {

                const targetBoxItem = event.target.closest(".box-item") ||
                    document.querySelector(`.box-item .js-second-step-product[data-second-step-product-handle="${productHandle}"]`)?.closest(".box-item");
                const notificationUl = targetBoxItem ? targetBoxItem.querySelector(".js-notification-ul") : null;
                if (notificationUl) {
                    notificationUl.insertAdjacentHTML("beforeend", `<li>Create Your Own ${productTitle} added to box</li>`);
                    setTimeout(() => {
                        const li = notificationUl.querySelector("li");
                        if (li) li.remove();
                    }, 1500);
                }

            }
            if (_this.stepTwoProducts.length === parseInt(productCount)) {
                //   document.querySelector(".js-next-button").removeAttribute("disabled");
                document.querySelector(".js-complete-button").removeAttribute("disabled");
                document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
                    thirdStepButton.removeAttribute("disabled");
                });
                //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
                //       forthStepButton.removeAttribute("disabled");
                //   });
                _this._showFullNotification();
            }
            if (event.target.closest(".js-product-modal")) {

                event.target.closest(".js-product-modal").classList.add("hidden");
                document.querySelector("body").classList.remove("popup-open");
            }

            // Update qty display counter after adding
            _this._updateQtyDisplay(productHandle);

            // Sync + button disabled state based on inventory
            _this._syncAllButtonsForHandle(productHandle, true);

            //  this.loadFromMemory();

        },

        nextStep: function (event) {
            const _this = this;
            _this.stepCount = _this.stepCount + 1;
            console.log(event, _this.stepCount)

            if (_this.stepCount === 2) {

                _this.stepTwoElement.classList.remove("hidden");
                _this.stepOneElement.classList.add("hidden");

            }
            if (_this.stepCount === 3) {
                _this.stepTwoElement.classList.add("hidden");
                _this.stepThreeElement.classList.remove("hidden");
                _this.stepCount = _this.stepCount - 1;
                event.target.classList.add("hidden");
                document.querySelector(".js-complete-button").classList.remove("hidden");
            }
            if (_this.stepCount === 4) {
                _this.stepTwoElement.classList.add("hidden");
                _this.stepThreeElement.classList.remove("hidden");
                _this.stepCount = _this.stepCount - 2;
                event.target.classList.add("hidden");
                document.querySelector(".js-complete-button").classList.remove("hidden");
            }
            const productCount = parseInt(localStorage.getItem("first-product-count"));
            if (_this.stepTwoProducts.length > productCount) {
                _this.stepTwoProducts.splice([_this.stepTwoProducts.length - 1], 1);
            }
            localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));
            if (_this.stepTwoProducts.length === productCount) {
                //   document.querySelector(".js-next-button").removeAttribute("disabled");
                document.querySelector(".js-complete-button").removeAttribute("disabled");
                document.querySelectorAll(".js-step-3-button").forEach((thirdStepButton) => {
                    thirdStepButton.removeAttribute("disabled");
                });
                //   document.querySelectorAll(".js-step-4-button").forEach((forthStepButton) => {
                //       forthStepButton.removeAttribute("disabled");
                //   });
            }

        },
        selectThirdStep: function (event) {
            const _this = this;
            const productHandle = event.target.closest(".js-third-step-product").getAttribute("data-third-step-product-handle");
            const productTitle = event.target.closest(".js-third-step-product").getAttribute("data-product-title");
            const extraBoxItem = document.querySelector(".js-extra-item");
            _this.stepCount = parseInt(this.stepThreeElement.getAttribute("data-step"));
            let fetchPromises = [];

            const targetBoxItemThird = event.target.closest(".box-item");
            const notificationUlThird = targetBoxItemThird ? targetBoxItemThird.querySelector(".js-notification-ul") : null;
            if (notificationUlThird) {
                notificationUlThird.insertAdjacentHTML("beforeend", `<li>${productTitle} added to box</li>`);
                setTimeout(() => {
                    const li = notificationUlThird.querySelector("li");
                    if (li) li.remove();
                }, 1500);
            }
            if (_this.stepThreeProducts.length > 0) {
                document.querySelectorAll(".js-extra-main").forEach((ele) => {
                    ele.classList.remove("hidden");
                })
            }
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < 4) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            _this.stepThreeProducts.push({ id: result, handle: productHandle });
            localStorage.setItem("third-step-product", JSON.stringify(_this.stepThreeProducts));
            for (let product of _this.stepThreeProducts) {
                fetchPromises.push(
                    fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
                        .then(res => {
                            if (!res.ok) {
                                throw new Error(`HTTP error! Status: ${res.status}`);
                            }
                            return res.json();
                        })
                        .then(request => {
                            if (!request || Object.keys(request).length === 0) {
                                throw new Error('Empty response or invalid JSON');
                            }
                            return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };


                        })
                        .catch(error => {
                            console.error(`Error fetching or processing product ${product}:`, error);
                            return { id: null, html: '' }; // Return placeholder data to maintain sequence
                        })
                );

            }
            Promise.all(fetchPromises)
                .then(results => {
                    const productMiniItems = [];
                    const imageItem = [];
                    results = results.filter(result => result.id !== null);

                    for (let [i, productData] of results.entries()) {
                        const { uid, id, title, image, price } = productData;
                        let currentProductHtml = `
                       <div class="items-list">
                            <div class="items-list__item">
                              <div class="item-image">
                                <img src="${image}" alt="${title}">
                              </div>
                              <div class="item-title-remove">
                                <h4>${title}</h4>
                               <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
                                <button class="delete-btn js-remove-extra-item" data-remove-item="${uid}">Remove</button>
                              </div>
                            </div>
                          </div>`;

                        productMiniItems.push(currentProductHtml);


                    }
                    let htmlToInsert = productMiniItems.join('');
                    extraBoxItem.innerHTML = htmlToInsert;

                    document.querySelectorAll(".js-remove-extra-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removeThirdStepItem.bind(this, index), true));

                })
                .catch(error => {
                    console.error('Error fetching or processing data:', error);
                });
            if (event.target.closest(".js-product-third-modal")) {

                event.target.closest(".js-product-third-modal").classList.add("hidden");
                document.querySelector("body").classList.remove("popup-open");
            }
        },
        completeBox: function (event) {
            const _this = this;

            requestAnimationFrame(() => {
                _this.stepOneElement.classList.add("hidden");
                _this.stepTwoElement.classList.add("hidden");
                _this.stepThreeElement.classList.add("hidden");
                _this.stepThreeElement.classList.remove("hidden");
                document.querySelector(".js-toolbar").classList.add("hidden");
            });

            _this.stepCount = 3;

            const boxItemForStepFour = document.querySelector(".js-box-item-step-four");
            const priceElement = document.querySelector(".js-total-price");

            priceElement.textContent = '$ 0.00';

            // 👉 SHOW LOADING
            boxItemForStepFour.innerHTML = `
        <div class="box-loading js-box-loading">
            <svg class="box-loading__spinner" width="32" height="32" viewBox="0 0 50 50">
            <circle
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
                stroke="#000"
                stroke-linecap="round"
                stroke-dasharray="31.4 31.4"
            >
                <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
                />
            </circle>
            </svg>
            <span class="box-loading__text">Loading products…</span>
        </div>
        `;

            Promise.all(
                _this.stepTwoProducts.map(product =>
                    fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
                        .then(res => res.ok ? res.json() : null)
                        .then(request => request ? {
                            uid: product.id,
                            id: request.id,
                            title: request.title,
                            image: request.featured_image,
                            price: request.price
                        } : null)
                        .catch(() => null)
                )
            )
                .then(results => {
                    const validResults = results.filter(Boolean);

                    // 👉 REMOVE LOADING
                    const loader = boxItemForStepFour.querySelector(".js-box-loading");
                    if (loader) loader.remove();

                    if (validResults.length === 0) {
                        priceElement.textContent = '$ 0.00';
                        boxItemForStepFour.innerHTML = '';
                        return;
                    }

                    const boxTotal = validResults.reduce((sum, p) => sum + p.price, 0);
                    localStorage.setItem("box-total-price", boxTotal);

                    boxItemForStepFour.innerHTML = validResults.map(({ uid, id, title, image, price }) =>
                        `<div class="box-items__item" data-id="${id}">
                        <div class="item-image">
                            <img src="${image}" alt="${title}" width="40" height="40">
                        </div>
                        <div class="item-info">
                            <div class="item-info__title">${title}</div>
                            <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
                            <div class="item-info__actions">
                                <button
                                type="button"
                                class="delete-btn js-box-item-remove-four"
                                data-remove-item="${uid}">
                                Remove
                                </button>
                            </div>
                        </div>
                    </div>`
                    ).join('');

                    priceElement.textContent = '$ ' + (boxTotal / 100).toFixed(2);

                    boxItemForStepFour.addEventListener("click", function (e) {
                        if (e.target.classList.contains("js-box-item-remove-four")) {
                            const index = Array
                                .from(boxItemForStepFour.querySelectorAll(".js-box-item-remove-four"))
                                .indexOf(e.target);

                            _this.removeBoxItemForStepFour(index, e);
                        }
                    });
                })
                .catch(error => {
                    console.error('Error:', error);

                    // 👉 ENSURE LOADING IS REMOVED ON ERROR
                    const loader = boxItemForStepFour.querySelector(".js-box-loading");
                    if (loader) loader.remove();

                    priceElement.textContent = '$ 0.00';
                });
        },


        editBox: function (event) {
            const _this = this;
            const addedProduct = JSON.parse(localStorage.getItem("second-step-product")) || [];
            const extraProduct = JSON.parse(localStorage.getItem("third-step-product")) || [];

            if (addedProduct.length > 0) {
                const editBoxItem = document.querySelector(".js-box-item");

                // 👉 SHOW LOADING IMMEDIATELY
                editBoxItem.innerHTML = `
                  <div class="box-loading js-edit-loading">
                      <svg class="box-loading__spinner" width="32" height="32" viewBox="0 0 50 50">
                          <circle
                              cx="25"
                              cy="25"
                              r="20"
                              fill="none"
                              stroke-width="5"
                              stroke="#000"
                              stroke-linecap="round"
                              stroke-dasharray="31.4 31.4"
                          >
                              <animateTransform
                                  attributeName="transform"
                                  type="rotate"
                                  from="0 25 25"
                                  to="360 25 25"
                                  dur="1s"
                                  repeatCount="indefinite"
                              />
                          </circle>
                      </svg>
                      <span class="box-loading__text">Loading your items…</span>
                  </div>
              `;

                // Show popup with loading state
                this.editModelElement.classList.remove("hidden");
                document.querySelector("body").classList.add("popup-open");

                // 👉 FETCH PRODUCTS LIKE IN completeBox
                let fetchPromises = [];
                for (let product of _this.stepTwoProducts) {
                    fetchPromises.push(
                        fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
                            .then(res => {
                                if (!res.ok) {
                                    throw new Error(`HTTP error! Status: ${res.status}`);
                                }
                                return res.json();
                            })
                            .then(request => {
                                if (!request || Object.keys(request).length === 0) {
                                    throw new Error('Empty response or invalid JSON');
                                }
                                return { uid: product.id, id: request.id, title: request.title, image: request.featured_image, price: request.price };
                            })
                            .catch(error => {
                                console.error(`Error fetching or processing product ${product}:`, error);
                                return { id: null, html: '' };
                            })
                    );
                }

                Promise.all(fetchPromises)
                    .then(results => {
                        const productMiniItems = [];
                        results = results.filter(result => result.id !== null);

                        for (let [i, productData] of results.entries()) {
                            const { uid, id, title, image, price } = productData;
                            let currentProductHtml = `
                          <div class="items-list" data-id="${id}">
                              <div class="items-list__item">
                                  <div class="item-image">
                                      <img src="${image}" alt="${title}">
                                  </div>
                                  <div class="item-title-remove">
                                      <h4>${title}</h4>
                                      <span class="item-price">$ ${(price / 100).toFixed(2)}</span>
                                      <button class="delete-btn js-remove-item" data-remove-item="${uid}">Remove</button>
                                  </div>
                              </div>
                          </div>`;
                            productMiniItems.push(currentProductHtml);
                        }

                        let htmlToInsert = productMiniItems.join('');

                        // 👉 REMOVE LOADING and show content
                        const loader = editBoxItem.querySelector(".js-edit-loading");
                        if (loader) loader.remove();

                        editBoxItem.innerHTML = htmlToInsert;

                        // Re-attach Remove listeners
                        document.querySelectorAll(".js-remove-item").forEach((removeButton, index) => removeButton.addEventListener("click", _this.removesecondStepItem.bind(_this, index), true));
                    })
                    .catch(error => {
                        console.error('Error fetching or processing data:', error);

                        // 👉 REMOVE LOADING on error
                        const loader = editBoxItem.querySelector(".js-edit-loading");
                        if (loader) loader.remove();

                        editBoxItem.innerHTML = '<p>Error loading products. Please try again.</p>';
                    });
            }
        },
        closeModel: function (event) {
            this.editModelElement.classList.add("hidden");
            document.querySelector("body").classList.remove("popup-open");
        },
        // removesecondStepItem: function (buttonIndex, event) {
        //     // console.log(event)
        //     const _this = this;
        //     const toolbar = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");

        //     const currentUniqueId = event.currentTarget.getAttribute("data-remove-item");
        //     // ── Get the handle BEFORE filtering so _updateQtyDisplay works correctly ──
        //     const removedProduct = _this.stepTwoProducts.find((product) => product.id == currentUniqueId);
        //     const removedHandle = removedProduct ? removedProduct.handle : null;
        //     _this.stepTwoProducts = _this.stepTwoProducts.filter((product) => product.id != currentUniqueId);

        //     if (removedHandle) {
        //         // re-enable is handled below by _syncAllButtonsForHandle
        //     }
        //     // console.log(_this.stepTwoProducts)
        //     // const newRemovedValue  = _this.stepTwoProducts.filter(item => item.ItemIndex !== variant.ItemIndex);
        //     localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

        //     // re-enable is handled below by _syncAllButtonsForHandle
        //     if (_this.stepTwoProducts.indexOf(buttonIndex) == -1) {
        //         event.target.closest(".items-list").remove();
        //     }

        //     // ── Redraw toolbar correctly from current stepTwoProducts array ──
        //     _this._redrawToolbar();

        //     _this.stepTwoElement.classList.remove("hidden");
        //     _this.stepThreeElement.classList.add("hidden");
        //     //   document.querySelector(".js-next-button").classList.remove("hidden");
        //     //   document.querySelector(".js-next-button").setAttribute("disabled", "");
        //     document.querySelector(".js-complete-button").setAttribute("disabled", "");
        //     document.querySelectorAll(".js-step-3-button").forEach((ele) => {
        //         ele.setAttribute("disabled", "");
        //     })

        //     // Update qty display after removing via sidebar Remove button
        //     if (removedHandle) {
        //         _this._updateQtyDisplay(removedHandle);
        //         // Sync + button state (re-enable if inventory allows)
        //         _this._syncAllButtonsForHandle(removedHandle);
        //     }

        //     /// check the index of array and li 


        // },
        removesecondStepItem: function (buttonIndex, event) {
            const _this = this;

            const currentUniqueId = event.currentTarget.getAttribute("data-remove-item");

            const removedProduct = _this.stepTwoProducts.find(product => product.id == currentUniqueId);
            const removedHandle = removedProduct ? removedProduct.handle : null;

            _this.stepTwoProducts = _this.stepTwoProducts.filter(product => product.id != currentUniqueId);

            localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

            // 🔥 NEW: Instantly update edit popup
            _this._rebuildEditPopup();

            event.target.closest(".items-list")?.remove();

            _this._redrawToolbar();

            document.querySelector(".js-complete-button").setAttribute("disabled", "");
            document.querySelectorAll(".js-step-3-button").forEach(ele => {
                ele.setAttribute("disabled", "");
            });

            if (removedHandle) {
                _this._updateQtyDisplay(removedHandle);
                _this._syncAllButtonsForHandle(removedHandle);
            }
        },

        removeThirdStepItem: function (buttonIndex, event) {
            const _this = this;
            const currentUniqueId = event.currentTarget.getAttribute("data-remove-item");
            _this.stepThreeProducts = _this.stepThreeProducts.filter((product) => product.id != currentUniqueId)
            localStorage.setItem("third-step-product", JSON.stringify(_this.stepThreeProducts));
            if (_this.stepThreeProducts.indexOf(buttonIndex) == -1) {
                event.target.closest(".items-list").remove();
            }
            if (_this.stepThreeProducts.length == 0) {
                document.querySelectorAll(".js-extra-main").forEach((elem) => {
                    elem.classList.add("hidden");
                });
            }
        },
        removeExtraItemStepFour: function (buttonIndex, event) {
            const _this = this;
            const currentUniqueId = event.currentTarget.getAttribute("data-remove-item");
            _this.stepThreeProducts = _this.stepThreeProducts.filter((product) => product.id != currentUniqueId)
            localStorage.setItem("third-step-product", JSON.stringify(_this.stepThreeProducts));

            if (_this.stepThreeProducts.indexOf(buttonIndex) == -1) {
                event.target.closest(".box-items__item").remove();
            }
            if (_this.stepThreeProducts.length == 0) {
                //   document.querySelector(".js-extra-item-main").classList.add("hidden");
                //   document.querySelector(".js-extra-item").querySelectorAll(".items-list")[buttonIndex].remove();
            }
            const extraItemForStepFour = document.querySelector(".js-extra-item-step-four");
            let fetchPromisesExtraItem = [];
            let extraProductPrice = [];
            if (_this.stepThreeProducts.length === 0) {
                let mainProductPrice = parseInt(localStorage.getItem("box-total-price"));
                document.querySelector(".js-total-price").innerHTML = '$ ' + (mainProductPrice / 100).toFixed(2);
            } else {

                //   document.querySelector(".js-extra-item-main").classList.remove("hidden");
                if (_this.stepThreeProducts.length > 0) {

                    for (let product of _this.stepThreeProducts) {
                        fetchPromisesExtraItem.push(
                            fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
                                .then(res => {
                                    if (!res.ok) {
                                        throw new Error(`HTTP error! Status: ${res.status}`);
                                    }
                                    return res.json();
                                })
                                .then(request => {
                                    if (!request || Object.keys(request).length === 0) {
                                        throw new Error('Empty response or invalid JSON');
                                    }


                                    extraProductPrice.push((request.price))
                                    let mainProductPrice = parseInt(localStorage.getItem("box-total-price"));
                                    let totalPrice = 0;
                                    for (let allPrice of extraProductPrice) {
                                        // mainProductPrice += allPrice;
                                        totalPrice = totalPrice + allPrice
                                    }

                                    document.querySelector(".js-total-price").innerHTML = '$ ' + ((totalPrice + mainProductPrice) / 100).toFixed(2);


                                })
                                .catch(error => {
                                    console.error(`Error fetching or processing product ${product}:`, error);
                                    return { id: null, html: '' }; // Return placeholder data to maintain sequence
                                })
                        );

                    }
                }
            }


        },
        removeBoxItemForStepFour: function (buttonIndex, event) {

            const _this = this;

            const button = event.target.closest(".js-box-item-remove-four");
            if (!button) return;

            const currentUniqueId = button.getAttribute("data-remove-item");
            const toolbar = this.giftBoxToolBar.querySelector(".js-toolbar-item").querySelectorAll("li");
            // 1️⃣ Remove correct product from array
            _this.stepTwoProducts = _this.stepTwoProducts.filter(product => product.id !== currentUniqueId);

            // 2️⃣ Update localStorage
            localStorage.setItem("second-step-product", JSON.stringify(_this.stepTwoProducts));

            // 3️⃣ Remove correct DOM element
            const itemElement = button.closest(".box-items__item");
            if (itemElement) itemElement.remove();

            // 4️⃣ If no products left → go back to Step 2
            if (event.target.closest(".items-list") && _this.stepTwoProducts.indexOf(buttonIndex) == -1) {
                event.target.closest(".items-list").remove();
            }

            // ── Redraw toolbar correctly from current stepTwoProducts array ──
            _this._redrawToolbar();

            _this.stepTwoElement.classList.remove("hidden");
            _this.stepThreeElement.classList.add("hidden");
            //   _this.stepFourElement.classList.add("hidden");
            //   document.querySelector(".js-next-button").classList.remove("hidden");
            //   document.querySelector(".js-next-button").setAttribute("disabled", "");
            document.querySelector(".js-complete-button").setAttribute("disabled", "");
            this.giftBoxToolBar.classList.remove("hidden");
            // 5️⃣ Recalculate total
            Promise.all(
                _this.stepTwoProducts.map(product =>
                    fetch(`${window.Shopify.routes.root}products/${product.handle}.js`)
                        .then(res => res.ok ? res.json() : null)
                        .catch(() => null)
                )
            ).then(results => {

                const valid = results.filter(Boolean);

                const newTotal = valid.reduce((sum, p) => sum + p.price, 0);

                localStorage.setItem("box-total-price", newTotal);

                const priceElement = document.querySelector(".js-total-price");
                if (priceElement) {
                    priceElement.textContent = '$ ' + (newTotal / 100).toFixed(2);
                }

            });
                  _this._rebuildEditPopup();
            // 6️⃣ Refresh inventory state
            _this.refreshStepTwoInventoryState();

            // 7️⃣ Update qty display counters
            _this._updateQtyDisplay();
        },
       


        // ── Helper: instantly rebuild the edit popup item list from cache (no fetch needed) ──
        // _rebuildEditPopup: function () {
        //     const _this = this;
        //     const editBoxItem = document.querySelector(".js-box-item");
        //     if (!editBoxItem) return;

        //     if (_this.stepTwoProducts.length === 0) {
        //         editBoxItem.innerHTML = "";
        //         return;
        //     }

        //     const html = _this.stepTwoProducts.map((product) => {
        //         const cached = _this._imageCache[product.handle] || {};
        //         const src = cached.src || "";
        //         const title = cached.title || product.handle;
        //         const price = cached.price || "";
        //         return `<div class="items-list">
        //         <div class="items-list__item">
        //             <div class="item-image">
        //                 <img src="${src}" alt="${title}">
        //             </div>
        //             <div class="item-title-remove">
        //                 <h4>${title}</h4>
        //                 <span class="item-price">${price}</span>
        //                 <button class="delete-btn js-remove-item" data-remove-item="${product.id}">Remove</button>
        //             </div>
        //         </div>
        //     </div>`;
        //     }).join("");

        //     editBoxItem.innerHTML = html;

        //     // Re-attach Remove listeners
        //     editBoxItem.querySelectorAll(".js-remove-item").forEach((btn, index) => {
        //         btn.addEventListener("click", _this.removesecondStepItem.bind(_this, index), true);
        //     });
        // },

        _rebuildEditPopup: function () {
    const _this = this;
    const editBoxItem = document.querySelector(".js-box-item");
    if (!editBoxItem) return;

    if (_this.stepTwoProducts.length === 0) {
        editBoxItem.innerHTML = "";
        return;
    }

    const html = _this.stepTwoProducts.map((product) => {
        const cached = _this._imageCache[product.handle] || {};
        const src = cached.src || "";
        const title = cached.title || product.handle;
        const price = cached.price || "";

        return `
        <div class="items-list">
            <div class="items-list__item">
                <div class="item-image">
                    <img src="${src}" alt="${title}">
                </div>
                <div class="item-title-remove">
                    <h4>${title}</h4>
                    <span class="item-price">${price}</span>
                    <button class="delete-btn js-remove-item" data-remove-item="${product.id}">
                        Remove
                    </button>
                </div>
            </div>
        </div>`;
    }).join("");

    editBoxItem.innerHTML = html;

    editBoxItem.querySelectorAll(".js-remove-item").forEach((btn, index) => {
        btn.addEventListener("click", _this.removesecondStepItem.bind(_this, index), true);
    });
},


        // ── Helper: sync BOTH the qty+ button AND the add-to-box button for a given handle ──
        _syncAllButtonsForHandle: function (handle, showNotification) {
            const _this = this;
            document.querySelectorAll(".box-item").forEach((boxItem) => {
                const addBtn = boxItem.querySelector(".js-second-step-product[data-second-step-product-handle]");
                if (!addBtn) return;
                if (addBtn.getAttribute("data-second-step-product-handle") !== handle) return;

                const inventoryQty = parseInt(boxItem.getAttribute("inventory-quantity")) || 0;
                const currentCount = _this.stepTwoProducts.filter(p => p.handle === handle).length;

                // Target both buttons inside this box-item with this handle
                const qtyPlusBtn = boxItem.querySelector(".qty-btn--plus");
                const addToBoxBtn = boxItem.querySelector(".btn--add-to-box.js-second-step-product");

                if (currentCount >= inventoryQty) {
                    // ── Disable qty + button ──
                    if (qtyPlusBtn) {
                        qtyPlusBtn.setAttribute("disabled", "");
                        qtyPlusBtn.setAttribute("inventory_sold", "true");
                    }
                    // ── Disable add-to-box button and show sold out ──
                    if (addToBoxBtn) {
                        addToBoxBtn.setAttribute("disabled", "");
                        addToBoxBtn.setAttribute("inventory_sold", "true");
                        addToBoxBtn.classList.add("sold-out");
                        const textSpan = addToBoxBtn.querySelector(".text");
                        if (textSpan) textSpan.textContent = "Sold Out";
                    }
                    // ── Show notification only when triggered by user action ──
                    if (showNotification) {
                        const notificationUl = boxItem.querySelector(".js-notification-ul");
                        if (notificationUl && !notificationUl.querySelector("li")) {
                            notificationUl.insertAdjacentHTML("beforeend", `<li>Max quantity added</li>`);
                            setTimeout(() => {
                                const li = notificationUl.querySelector("li");
                                if (li) li.remove();
                            }, 2000);
                        }
                    }
                } else {
                    // ── Re-enable qty + button ──
                    if (qtyPlusBtn) {
                        qtyPlusBtn.removeAttribute("disabled");
                        qtyPlusBtn.removeAttribute("inventory_sold");
                    }
                    // ── Re-enable add-to-box button ──
                    if (addToBoxBtn) {
                        addToBoxBtn.removeAttribute("disabled");
                        addToBoxBtn.removeAttribute("inventory_sold");
                        addToBoxBtn.classList.remove("sold-out");
                        const textSpan = addToBoxBtn.querySelector(".text");
                        if (textSpan) textSpan.textContent = "Add to box";
                    }
                }
            });
        },

        // ── Helper: show "box is full" notification in .js-notification-ul-full ──
        _showFullNotification: function () {
            const ul = document.querySelector(".js-notification-ul-full");
            if (!ul) return;
            // Clear any existing message first to avoid stacking
            ul.innerHTML = "";
            ul.insertAdjacentHTML("beforeend", "<li>Your Gift Box is full!</li>");
            setTimeout(() => {
                const li = ul.querySelector("li");
                if (li) li.remove();
            }, 2500);
        },

        // ── Helper: instantly redraw all toolbar li images from stepTwoProducts + imageCache ──
        _redrawToolbar: function () {
            const toolBarItems = this.giftBoxToolBar
                .querySelector(".js-toolbar-item")
                .querySelectorAll("li");

            toolBarItems.forEach((li, index) => {
                // Only touch visible (non-hidden) slots
                if (li.classList.contains("hidden")) {
                    li.innerHTML = "";
                    return;
                }
                const product = this.stepTwoProducts[index];
                if (product) {
                    const cached = this._imageCache[product.handle];
                    if (cached) {
                        li.innerHTML = `<img src="${cached.src}" alt="${cached.alt}" data-handle="${product.id}">`;
                    }
                    // if no cache entry yet, leave existing content (edge case)
                } else {
                    // slot is empty — clear it
                    li.innerHTML = "";
                }
            });
        },

        // ── Helper: update qty display badge for one handle (or all if no handle given) ──
        _updateQtyDisplay: function (handle) {
            const _this = this;
            document.querySelectorAll(".box-item").forEach((boxItem) => {
                const btn = boxItem.querySelector(".js-second-step-product");
                if (!btn) return;

                const itemHandle = btn.getAttribute("data-second-step-product-handle");

                // If a specific handle is given, only update that card
                if (handle !== undefined && itemHandle !== handle) return;

                const count = _this.stepTwoProducts.filter(p => p.handle === itemHandle).length;
                const display = boxItem.querySelector(".js-qty-display");
                const minusBtn = boxItem.querySelector(".js-qty-minus");

                if (display) display.textContent = count;
                if (minusBtn) minusBtn.disabled = count === 0;
            });
        },

        addToGiftBox: function (event) {
            const _this = this;
            const giftMessageValue = this.giftMessageElement.value;
            const mainProduct = localStorage.getItem("first-step-product");

            // Generate unique bundle ID
            const uniqueBundleId = Date.now().toString();

            const property = {
                "Gift Message": giftMessageValue,
                "unique_id": "main_product"
            };

            // Disable button and add loading state
            _this.addToGiftButtonElement.setAttribute("disabled", "");
            const originalButtonText = _this.addToGiftButtonElement.innerHTML;
            _this.addToGiftButtonElement.innerHTML = '<span class="loading-spinner"></span> Adding...';

            let deliveryOption;
            _this.deliveryOptionElements.forEach((option) => {
                if (option.checked === true) {
                    deliveryOption = option.value;
                }
            });

            const formData1 = {
                items: []
            };

            const formData2 = {
                items: []
            };

            let boxProduct = [];
            let extProduct = [];

            const allProductOfBox = [];
            const allProductOfExtra = [];

            // Process main product (the gift box itself)
            const processMainProduct = () => {
                if (mainProduct) {
                    return fetch(`${window.Shopify.routes.root}products/${mainProduct}.js`)
                        .then(res => res.json())
                        .then(request => {
                            const mainProductItem = {
                                id: request.variants[0].id,
                                quantity: 1,
                                properties: {
                                    "Gift Message": giftMessageValue,
                                    "Delivery Option": deliveryOption,
                                    "unique_id": "main_product",
                                    "_bundleId": uniqueBundleId
                                }
                            };
                            return fetch(window.Shopify.routes.root + 'cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ items: [mainProductItem] })
                            }).then(response => response.json());
                        })
                        .catch(error => {
                            console.error('Error adding main product:', error);
                            return Promise.resolve();
                        });
                } else {
                    return Promise.resolve();
                }
            };

            const processBoxProducts = () => {
                if (_this.stepTwoProducts.length === allProductOfBox.length && boxProduct.length > 0) {
                    const counts = {};
                    allProductOfBox.forEach(x => counts[x] = (counts[x] || 0) + 1);
                    const boxProductSummary = Object.entries(counts).map(([title, count]) => `${title}: ${count}`).join(', ');
                    localStorage.setItem("boxProduct", JSON.stringify(boxProductSummary));
                    formData1.items = boxProduct;
                    return fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData1)
                    }).then(response => response.json());
                } else {
                    return Promise.resolve();
                }
            };

            const processExtraProducts = () => {
                if (_this.stepThreeProducts.length === allProductOfExtra.length && extProduct.length > 0) {
                    const counts = {};
                    allProductOfExtra.forEach(x => counts[x] = (counts[x] || 0) + 1);
                    const extraProductSummary = Object.entries(counts).map(([title, count]) => `${title}: ${count}`).join(', ');
                    localStorage.setItem("extraProduct", JSON.stringify(extraProductSummary));
                    formData2.items = extProduct;
                    return fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData2)
                    }).then(response => response.json());
                } else {
                    return Promise.resolve();
                }
            };

            const fetchBoxProducts = _this.stepTwoProducts.map(boxItem => {
                return fetch(`${window.Shopify.routes.root}products/${boxItem.handle}.js`)
                    .then(res => res.json())
                    .then(request => {
                        allProductOfBox.push(request.title);
                        boxProduct.push({
                            id: request.variants[0].id,
                            quantity: 1,
                            properties: {
                                Message: giftMessageValue,
                                "Delivery Option": deliveryOption,
                                "Box item": true,
                                "_bundleId": uniqueBundleId
                            }
                        });
                    })
                    .catch(error => console.error('Error fetching box product:', error));
            });

            const fetchExtraProducts = _this.stepThreeProducts.map(extraItem => {
                return fetch(`${window.Shopify.routes.root}products/${extraItem.handle}.js`)
                    .then(res => res.json())
                    .then(request => {
                        allProductOfExtra.push(request.title);
                        extProduct.push({
                            id: request.variants[0].id,
                            quantity: 1,
                            properties: { Message: giftMessageValue, "Delivery Option": deliveryOption, "Extra item": true }
                        });
                    })
                    .catch(error => console.error('Error fetching extra product:', error));
            });

            // Add main product first, then box products, then extra products
            processMainProduct()
                .then(() => Promise.all([...fetchBoxProducts, ...fetchExtraProducts]))
                .then(() => processBoxProducts())
                .then(() => processExtraProducts())
                .then(() => {
                    // Remove loading state
                    _this.addToGiftButtonElement.removeAttribute("disabled");
                    _this.addToGiftButtonElement.innerHTML = originalButtonText;

                    setTimeout(() => {
                        window.location.href = window.Shopify.routes.root + 'cart';
                    }, 500);
                })
                .catch(error => {
                    console.error('Error:', error);
                    // Remove loading state on error
                    _this.addToGiftButtonElement.removeAttribute("disabled");
                    _this.addToGiftButtonElement.innerHTML = originalButtonText;
                    alert('There was an error adding items to cart. Please try again.');
                });
        }



    }
    giftBoxBuilder.init();
})();